import React, { useState, useEffect, useRef } from "react";
import DiagnosticReferralButton from "./DiagnosticReferral";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Avatar,
  Autocomplete,
  Chip,
  CircularProgress,
  Stack,
  Grid,
  Button,
  Tabs,
  Tab,
  Divider,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel, 
  Select,
  MenuItem,
  TablePagination,
  TableContainer,
  FormControlLabel,
  Checkbox ,
  FormHelperText,
  Collapse,
} from "@mui/material";

import {
  Person,
  Search,
  LocalHospital,
  Science,
  Notes,
  LocalPharmacy,
  CalendarMonth,
  Print,
  Send,
  History,
  Close,
  Scanner,
  Medication,
  RoomService,
  Hotel,
  PersonAdd ,
   AutoAwesome ,
   CameraAlt ,Delete,
  Info
} from "@mui/icons-material";


import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { suggestionsData } from "../data/suggestionsData";
import { diagnosisRules } from "../data/diagnosisRules";
import SaveIcon from "@mui/icons-material/Save";
import { Edit, ArrowBack, ArrowBackIosNew, ArrowForwardIos, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import PatientTable from '../Wards/PatientTable';
import { ErrorMessage, successMessage ,frequencyMap ,frequencyMultiplier ,standardFrequencies ,MEDICATION_ROUTES ,formatAge } from "../Message";
import { generateNote } from "../BaseURL";
import { loadAllPatientsToday , loadInsuredServicesdb ,loadDoctorSuggestionsdb ,loadPatientDiagnosisdb
  ,servicesToday ,saveServiceProvideddb ,saveOrUpdateDiagnosisdb ,loadDiagnosisOptionsdb ,loadProcedureOptionsdb ,
  saveOrUpdateDiagnosisDocumetingdb ,saveOrUpdateProceduresDocumetingdb ,loadLabdb ,requestLab ,loadRequestedLabsdb
 ,deleteRequestedLabdb ,loadAvailableScansdb ,loadRequestedScandb ,loadMedicationsdb ,addMedicationdb , loadRequestedMedsdb 
  ,updateMedicationdb ,medicationdeletedb ,loadOtherServicesdb ,requestOtherService ,loadRequestedOtherServicesdb ,saveAppointmentdb, 
  loadAppointmentsdb, updateAppointmentdb, deleteAppointmentdb ,getPatientAppointmentdb ,admitPatient ,loadMedicationByAge ,outpatientStatsdb 
  ,deleteOrReverseOtherServicedb , notifyPharmacyRestock ,stockControlSetting ,saveChronicMedication , loadChronicMedicationdb ,medicationStock ,scheduleAppointmentSms} from '../BaseURL';


import Swal from "sweetalert2";
//  Which patients a medicine may be prescribed to, and the way past the filter
//  when the patient genuinely needs something outside their band.
import { AgeBandChip, AgeBandNotice } from './MedicationAgeBand';
import { formatWithOutSom } from "../Message";
import MedicalHistoryDialog from "./MedicalHistoryDialog";
import LabHistoryDialog from "./LabHistoryDialog";
import ScanHistoryDialog from "./ScanHistoryDialog";
import MedicationHistory from "../Pharmacy/MedicationHistory";
import VitalsHistoryDialog from "./VitalsHistoryDialog";
import SpecialPrecautionDialog from "./SpecialPrecautionDialog";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ChronicMedicationDialog from "./ChronicMedicationDialog";
import moment from "moment";
import PatientHeaderCard from '../Shared/PatientHeaderCard';


const OutPatient = () => {
 
  const [outpatientStats, setOutpatientStats] = useState({
  totalOutpatients: 0,
  maleCount: 0,
  femaleCount: 0,
  pediatricsCount: 0,
  adultCount: 0
});
  const [loading, setLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [allPatients ,setAllPatients] = useState([]);

  // Server-side worklist pagination. The endpoint returns one page at a
  // time — we don't hold the full 13k-row list in memory anymore.
  const [worklistPage, setWorklistPage]           = useState(0);
  const [worklistRowsPerPage, setWorklistRowsPerPage] = useState(25);
  const [worklistSearch, setWorklistSearch]       = useState('');
  // Default sort: arrival time ascending (earliest visit today at the top).
  // The `visitDate` sort key maps to `p.currtime` on the backend, so this
  // orders by the exact clock-in moment rather than the calendar day.
  const [worklistOrderBy, setWorklistOrderBy]     = useState('visitDate');
  const [worklistOrder, setWorklistOrder]         = useState('desc');
  const [worklistTotal, setWorklistTotal]         = useState(0);

  // Auto-collapsing patient banner via IntersectionObserver on a sentinel —
  // see Wards/InPatient.js for the rationale. Cooldown prevents the layout
  // shift caused by the Collapse animation from immediately re-triggering
  // the observer (the scroll-listener version bounced in/out endlessly).
  const [bannerCollapsed, setBannerCollapsed] = useState(false);
  const [bannerManual, setBannerManual]       = useState(false);
  const bannerSentinelRef = useRef(null);
  const bannerCooldownRef = useRef(false);
  useEffect(() => {
    if (bannerManual) return;
    const el = bannerSentinelRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (bannerCooldownRef.current) return;
        bannerCooldownRef.current = true;
        setTimeout(() => { bannerCooldownRef.current = false; }, 350);
        setBannerCollapsed(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [bannerManual, selectedPatient?.id]);
  useEffect(() => {
    setBannerCollapsed(false);
    setBannerManual(false);
  }, [selectedPatient?.id]);

const [serviceProvided, setServiceProvided] = useState('');
const [attendanceType, setAttendanceType] = useState('');
const [precautionDialogOpen, setPrecautionDialogOpen] = useState(false);
const [doseAmount, setDoseAmount] = useState("");
const [doseUnit, setDoseUnit] = useState("");
const [medSearchTerm, setMedSearchTerm] = useState("");
const [selectedMed, setSelectedMed] = useState(null);
const [dose, setDose] = useState("");
const [frequency, setFrequency] = useState("");
const [days, setDays] = useState("");
const [qty, setQty] = useState(0);
const [route, setRoute] = useState("");
const [requestedMeds, setRequestedMeds] = useState([]);
const [autoCalculate, setAutoCalculate] = useState(true);
const [chronicDialogOpen, setChronicDialogOpen] = useState(false);
const [chronicMeds, setChronicMeds] = useState([]);

// Manual service request
const [manualServiceName, setManualServiceName] = useState("");
const [manualQty, setManualQty] = useState(1);
const [manualAmount, setManualAmount] = useState("");

const [isLoadingDiagnosis, setIsLoadingDiagnosis] = useState(false);

const [medInfoDialogOpen, setMedInfoDialogOpen] = useState(false);
const [selectedMedInfo, setSelectedMedInfo] = useState(null);
const [medInfoLoading, setMedInfoLoading] = useState(false);

const loadOutpatientStats = async () => {
  try {
    const response = await axios.get(outpatientStatsdb);
    
    if (response.data.success) {
      setOutpatientStats({
        totalOutpatients: response.data.total || 0,
        maleCount: response.data.male || 0,
        femaleCount: response.data.female || 0,
        pediatricsCount: response.data.pediatrics || 0,
        adultCount: response.data.adult || 0
      });
    }
  } catch (error) {
    console.error("Error loading outpatient stats:", error);
  }
}


useEffect(() => {
  loadOutpatientStats();
  
  // Refresh stats every 30 seconds
  const interval = setInterval(() => {
    loadOutpatientStats();
  }, 30000);

  return () => clearInterval(interval);
}, []);


// ── Patient navigation (prev / next within the worklist) ───────────────
const currentPatientIndex = selectedPatient
  ? allPatients.findIndex(p => p.id === selectedPatient.id)
  : -1;
const hasPrevPatient = currentPatientIndex > 0;
const hasNextPatient = currentPatientIndex >= 0 && currentPatientIndex < allPatients.length - 1;
const goToPrevPatient = () => {
  if (hasPrevPatient) setSelectedPatient(allPatients[currentPatientIndex - 1]);
};
const goToNextPatient = () => {
  if (hasNextPatient) setSelectedPatient(allPatients[currentPatientIndex + 1]);
};

// Keyboard shortcuts: ← previous patient · → next patient
// Disabled while typing in inputs/textareas/selects.
useEffect(() => {
  if (!selectedPatient) return;
  const onKey = (e) => {
    const tag = (e.target?.tagName || '').toLowerCase();
    const editable = e.target?.isContentEditable;
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || editable) return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goToPrevPatient(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); goToNextPatient(); }
  };
  window.addEventListener('keydown', onKey);
  return () => window.removeEventListener('keydown', onKey);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedPatient, allPatients]);


const [medHistoryOpen, setMedHistoryOpen] = useState(false);
const [labHistoryOpen, setlabHistoryOpen] = useState(false);
const [ScanHistoryOpen, setScanHistoryOpen] = useState(false);
const [openmedHis, setopenmedHis] = useState(false);
const [vitalsHistoryOpen, setVitalsHistoryOpen] = useState(false);


// Pharmacy stock control master switch (System Settings → Pharmacy).
// Defaults to true so that if the fetch fails we keep the existing, safer
// behaviour rather than silently letting stock checks lapse.
const [stockControlOn, setStockControlOn] = useState(true);

useEffect(() => {
  let cancelled = false;
  axios.get(stockControlSetting)
    .then((r) => { if (!cancelled && r.data?.success) setStockControlOn(r.data.enabled !== false); })
    .catch(() => { /* keep the default (on) */ });
  return () => { cancelled = true; };
}, []);

const [stockWarningDialog, setStockWarningDialog] = useState(false);
const [stockWarningInfo, setStockWarningInfo]   = useState(null);
const [notifyingPharmacy, setNotifyingPharmacy] = useState(false);


const [complaint, setComplaint] = useState("");
const [history, setHistory] = useState("");
const [exam, setExam] = useState("");
const [other, setOther] = useState("");


const ensureServiceAndAttendanceSelected = () => {
  if (!serviceProvided || !attendanceType) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please select both 'Service Provided' and 'Type of Attendance' before proceeding.",
    });
    return false;
  }
  return true;
};


const [currentUser ,setcurrentUser]=useState()


// Server-paginated worklist fetch. Debounced search + a per-request seq
// guard prevent race conditions where an older, slower response overwrites
// the current one when the user types quickly or paginates.
const worklistReqSeqRef = useRef(0);
const loadPatients = async ({
  page = worklistPage,
  limit = worklistRowsPerPage,
  search = worklistSearch,
  orderBy = worklistOrderBy,
  order = worklistOrder,
} = {}) => {
  const seq = ++worklistReqSeqRef.current;
  setLoading(true);
  try {
    const response = await axios.get(loadAllPatientsToday, {
      params: { page, limit, search, orderBy, order },
    });
    if (seq !== worklistReqSeqRef.current) return; // stale response
    if (response.data.success) {
      setAllPatients(response.data.results);
      setWorklistTotal(response.data.total || 0);
    }
  } catch (error) {
    console.error("Request failed:", error);
  } finally {
    if (seq === worklistReqSeqRef.current) setLoading(false);
  }
};

const [diagnosisOptions, setDiagnosisOptions] = useState([]);
const [procedureOptions ,setprocedureOptions]= useState([])


const loadDiagnosisOptions = async (age , gender , status)  => {
   setLoading(true);
  try {
    const response = await axios.get(loadDiagnosisOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setDiagnosisOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};


const loadProcedureOptions = async (age , gender , status)  => {
 
   setLoading(true);
  try {
    const response = await axios.get(loadProcedureOptionsdb, {
      params: {
        age: age,
        gender: gender ,
        status:status
      }
    });

    if (response.data.success) {
      setprocedureOptions(response.data.results);
    }
  } catch (error) {
    console.error('Error loading diagnosis options:', error);
  }finally {
    setLoading(false);
  }
};

useEffect(() => {
    const savedUserInfo = localStorage.getItem('userInfo');
      if (savedUserInfo) {
        const userInfo = JSON.parse(savedUserInfo);
        const userName = userInfo.name || '';
        setcurrentUser(userName)

         if (userName) loadDoctorSuggestions(userName);
      }

}, []);

// Refetch the worklist whenever paging or sort changes. Search is debounced
// separately below so typing doesn't fire a request on every keystroke.
useEffect(() => {
  loadPatients({
    page: worklistPage,
    limit: worklistRowsPerPage,
    orderBy: worklistOrderBy,
    order: worklistOrder,
    search: worklistSearch,
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [worklistPage, worklistRowsPerPage, worklistOrderBy, worklistOrder]);

// Debounced search — wait 300ms after the user stops typing before hitting
// the API. Skips the initial mount (the pagination effect above handles
// the first fetch) so we don't fire two requests on load.
const worklistSearchInitRef = useRef(true);
useEffect(() => {
  if (worklistSearchInitRef.current) {
    worklistSearchInitRef.current = false;
    return;
  }
  const t = setTimeout(() => {
    setWorklistPage(0);
    loadPatients({
      page: 0,
      limit: worklistRowsPerPage,
      orderBy: worklistOrderBy,
      order: worklistOrder,
      search: worklistSearch,
    });
  }, 300);
  return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [worklistSearch]);

const [customSuggestions, setCustomSuggestions] = useState({});

const loadDoctorSuggestions = async (doctorName) => {
   setLoading(true);
  try {
    const response = await axios.get(loadDoctorSuggestionsdb, {
      params: { doctorName }
    });

    if (response.data.success) {
      setCustomSuggestions(response.data.data);

      // ✅ Merge backend doctor suggestions with local suggestionsData
      Object.keys(response.data.data).forEach((field) => {
        const backendItems = response.data.data[field] || [];
        const merged = [
            ...new Set([...backendItems, ...suggestionsData[field]])
        ];
        suggestionsData[field] = merged; // extend in-memory data
      });

      console.log("Updated suggestionsData with backend doctor data:", suggestionsData);
    }
  } catch (error) {
    console.error("Error loading doctor suggestions:", error);
  }finally {
    setLoading(false);
  }
};

const loadServiceAndAttendance = async (patientId , dat) => {
 setLoading(true);
  try {
    const response = await axios.get(servicesToday, {
      params: { patient_id: patientId , dat:dat }
    });

    if (response.data.success && response.data.data) {
      const { name, att } = response.data.data;
      setServiceProvided(name || '');
      setAttendanceType(att || '');
    } else {
      setServiceProvided('');
      setAttendanceType('');
    }
  } catch (error) {
    console.error('Error loading service and attendance:', error);
  }finally {
    setLoading(false);
  }
};


const [insuredServices, setInsuredServices] = useState([]);

const loadInsuredServices = async (insuranceName, patientAge, gender) => {
  setLoading(true);
  try {
  
    const response = await axios.get(loadInsuredServicesdb, {
      params: {
        STATUS: insuranceName,
        charge_status: "Main Services",
        patientAge: patientAge, // 👈 send age here
        //  The server withholds sex-specific services that cannot apply —
        //  antenatal care for a man, circumcision for a woman. Omitted when no
        //  sex is recorded, and the full list comes back.
        gender: gender || undefined,
      },
    });

    if (response.data.success) {
      setInsuredServices(response.data.results);
      console.log("Loaded insured services:", response.data.results);
    } else {
      setInsuredServices([]);
    }
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.response?.data?.message || "Failed to load insured services",
      icon: "error",
    });
  }finally {
    setLoading(false);
  }
};

//  Male when the record plainly says so. Blank, '-' or 'other' is NOT male, so
//  an unrecorded sex never hides the antenatal/postnatal options.
const isMalePatient = /^m/i.test(String(selectedPatient?.gender || '').trim());

const [aiDraftingNote, setAiDraftingNote] = useState(false);

/*  Draft the consultation note from the doctor's own diagnosis.
 *
 *  The same /generateNote the claims screen uses, asked for BRIEF output — one
 *  line of complaint, a line or two of history and examination, the way an OPD
 *  clinician actually writes. Whatever the doctor has already typed is sent
 *  along and refined rather than replaced. Nothing is saved: the draft lands in
 *  the boxes and is saved with the consultation, after the doctor has read it. */
const handleAIDraftNote = async () => {
  try {
    const licenseAI = JSON.parse(localStorage.getItem('license_ai') || '{"allowed":true}');
    if (licenseAI.allowed === false) {
      ErrorMessage('AI licence', licenseAI.reason || 'AI features are not licensed for this facility.');
      return;
    }
  } catch { /* allow */ }

  if (!selectedPatient) return;
  if (!selectedDiagnoses || selectedDiagnoses.length === 0) {
    ErrorMessage('Diagnosis required', 'Select at least one diagnosis first — the note is written up from it.');
    return;
  }

  setAiDraftingNote(true);
  try {
    const hasExistingNotes = !!(complaint?.trim() || history?.trim() || exam?.trim() || other?.trim());
    const hasProcedures = !!(selectedProcedures && selectedProcedures.length);
    const res = await axios.post(generateNote, {
      patientId: selectedPatient.id,
      age: selectedPatient.age,
      gender: selectedPatient.gender,
      attendanceType,
      serviceProvided,
      diagnoses: selectedDiagnoses.map((d) => ({ id: d.id, name: d.name, code: d.code })),
      procedures: hasProcedures
        ? selectedProcedures.map((p) => ({ id: p.id, name: p.name, code: p.code }))
        : [],
      hasProcedures,
      hasExistingNotes,
      opdComplaint: complaint?.trim() || '',
      opdHistory: history?.trim() || '',
      opdExam: exam?.trim() || '',
      opdOther: other?.trim() || '',
      isOPD: true,
      isDischarge: false,
      isDetention: false,
      generationIndex: 0,
      excludeNamesFromNotes: true,
      //  Short, consulting-room style. See /generateNote.
      brief: true,
    });

    const ai = res?.data?.data || {};
    if (!res?.data?.success) {
      ErrorMessage('Draft failed', res?.data?.message || 'The note could not be drafted.');
      return;
    }
    //  Only fields the AI actually filled. An empty history or other
    //  documentation is a normal brief note, not something to clear the box for.
    if (ai.complaint?.trim())          setComplaint(ai.complaint.trim());
    if (ai.patientHistory?.trim())     setHistory(ai.patientHistory.trim());
    if (ai.physicalExam?.trim())       setExam(ai.physicalExam.trim());
    if (ai.otherDocumentation?.trim()) setOther(ai.otherDocumentation.trim());
    setHasEdited(true);
  } catch (e) {
    ErrorMessage('Draft failed', e?.response?.data?.message || e.message || 'The note could not be drafted.');
  } finally {
    setAiDraftingNote(false);
  }
};

const loadChronicMedication = async () => {
  if (!selectedPatient) return [];

  try {
    const res = await axios.get(loadChronicMedicationdb, {
      params: { patientId: selectedPatient.id }
    });

    if (res.data.success) {
      console.log("✅ Chronic meds loaded:", res.data.medications);
      setChronicMeds(res.data.medications);

      // Auto-open dialog only if meds exist
      if (res.data.medications.length > 0) {
        setChronicDialogOpen(true);
      }
      
      return res.data.medications; // ✅ Return the data
    }
    
    return [];
  } catch (err) {
    console.log("Error loading chronic meds:", err);
    return [];
  }
};


// when patient is selected, load services automatically
useEffect(() => {
  if (selectedPatient) {
    setActiveTab(0);

    // Load the patient's dashboard in a single parallel batch. The old
    // fire-and-forget style also ran in parallel at the network level,
    // but every loader toggled the shared `loading` state independently,
    // causing 13+ back-to-back re-render cycles and no clear "everything
    // is loaded" moment. Wrapping in Promise.all:
    //   1. Fires all requests at once (same as before)
    //   2. Gives a single completion callback (predictable spinner)
    //   3. `.catch` per call means one slow/failing endpoint doesn't
    //      stop the others from populating the panel
    const loadPatientData = async () => {
      // Step 1: Chronic medications first — its result is consumed by
      // loadMedications below (real data dependency).
      const chronicMedsData = await loadChronicMedication();

      // Step 2: Everything else runs in parallel.
      const swallow = (label) => (err) => console.error(`[OutPatient] ${label} failed:`, err);
      await Promise.all([
        loadInsuredServices(selectedPatient.insurance, selectedPatient.age, selectedPatient.gender).catch(swallow('loadInsuredServices')),
        loadServiceAndAttendance(selectedPatient.id, selectedPatient.visitDate).catch(swallow('loadServiceAndAttendance')),
        loadDiagnosisOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance).catch(swallow('loadDiagnosisOptions')),
        loadProcedureOptions(selectedPatient.age, selectedPatient.gender, selectedPatient.insurance).catch(swallow('loadProcedureOptions')),
        loadLabs().catch(swallow('loadLabs')),
        loadRequestedLabs().catch(swallow('loadRequestedLabs')),
        loadAvailableScans().catch(swallow('loadAvailableScans')),
        loadRequestedScan().catch(swallow('loadRequestedScan')),
        loadMedications(chronicMedsData).catch(swallow('loadMedications')),
        loadRequestedMeds().catch(swallow('loadRequestedMeds')),
        loadOtherServices().catch(swallow('loadOtherServices')),
        loadrequestedServices().catch(swallow('loadrequestedServices')),
        loadPatientAppointments().catch(swallow('loadPatientAppointments')),
      ]);
    };

    loadPatientData();

    if (selectedPatient.PrecautionType && selectedPatient.PrecautionType.trim() !== '') {
      setPrecautionDialogOpen(true);
    }
  }
}, [selectedPatient]);



/*  The consultation note is fetched as soon as a patient is picked.
 *
 *  This used to also require diagnosisOptions.length > 0 AND
 *  procedureOptions.length > 0. Those are TARIFF lookups, not note data:
 *  /loadProcedureOptions is
 *      WHERE status = <the patient's Insurance> AND (age = <band> OR 'Both')
 *  so a facility whose procedure_tarf carries no row for that exact insurance
 *  string gets an empty list — and the complaint, history, examination and
 *  other documentation were then NEVER FETCHED AT ALL. The text sat in the
 *  diagnosis table, correctly dated, invisible to the doctor who typed it.
 *
 *  The note text does not depend on either list. Only the diagnosis and
 *  procedure CHIPS do, and they re-match themselves below once the lists land.
 */
useEffect(() => {
  if (selectedPatient && selectedPatient.id) {
    loadPatientDiagnosis(selectedPatient.id, selectedPatient.visitDate);
  }
}, [selectedPatient]);


const [hasEdited, setHasEdited] = useState(false);
const [Diagnosis, setDiagnosis] = useState();
const [procedure_, setprocedure_] = useState();


const loadPatientDiagnosis = async (patientId, dat) => {
  setLoading(true);
  setIsLoadingDiagnosis(true); // ⭐ block autosave

  try {
    const response = await axios.get(loadPatientDiagnosisdb, {
      params: { patientId, dat },
    });

    // ❌ DON'T clear immediately anymore
    // Clearing causes autosave("") bug

    if (!response.data.success || !response.data.data) {
      // Only clear AFTER fetch completes
      setComplaint("");
      setHistory("");
      setExam("");
      setOther("");
      setSelectedDiagnoses([]);
      setSelectedProcedures([]);
      setHasEdited(false);
      return;
    }

    const { complaint, history, exam, other, documenting, procedure_ } =
      response.data.data;

    // ✅ Load text safely
    setComplaint(complaint || "");
    setHistory(history || "");
    setExam(exam || "");
    setOther(other || "");

    setDiagnosis(documenting);
    setprocedure_(procedure_);

    // ---------- Diagnoses ----------
    if (documenting?.trim()) {
      const parsed = documenting.split(",").map(x => x.trim());

      const matched = diagnosisOptions.filter(opt =>
        parsed.some(p => opt.name.toLowerCase() === p.toLowerCase())
      );

      setSelectedDiagnoses(matched);
    } else {
      setSelectedDiagnoses([]);
    }

    // ---------- Procedures ----------
    if (procedure_?.trim()) {
      const parsed = procedure_.split(",").map(x => x.trim());

      const matched = procedureOptions.filter(opt =>
        parsed.some(p => opt.name.toLowerCase() === p.toLowerCase())
      );

      setSelectedProcedures(matched);
    } else {
      setSelectedProcedures([]);
    }

    setHasEdited(false); // ⭐ important
  } catch (error) {
    console.error("Error loading diagnosis:", error);
  } finally {
    setIsLoadingDiagnosis(false); // ⭐ unblock autosave
    setLoading(false);
  }
};

/*  Re-match the saved diagnosis and procedure CHIPS when their tariff lists
 *  arrive.
 *
 *  loadPatientDiagnosis no longer waits for those lists (see the note above it),
 *  so on the first pass they can still be empty and nothing matches. `Diagnosis`
 *  and `procedure_` hold the saved comma-separated names the server returned, so
 *  the match is simply re-run whenever either list changes.
 *
 *  Neither of these writes anything. The diagnosis and procedure saves fire from
 *  the Autocomplete onChange handlers only — no effect in this file watches
 *  selectedDiagnoses or selectedProcedures — so restoring the saved selection
 *  cannot trigger a save, and cannot mark the form edited.
 */
useEffect(() => {
  if (!diagnosisOptions.length || !Diagnosis?.trim()) return;
  const parsed = Diagnosis.split(",").map(x => x.trim()).filter(Boolean);
  setSelectedDiagnoses(
    diagnosisOptions.filter(opt =>
      parsed.some(p => opt.name?.toLowerCase() === p.toLowerCase()))
  );
}, [Diagnosis, diagnosisOptions]);

useEffect(() => {
  if (!procedureOptions.length || !procedure_?.trim()) return;
  const parsed = procedure_.split(",").map(x => x.trim()).filter(Boolean);
  setSelectedProcedures(
    procedureOptions.filter(opt =>
      parsed.some(p => opt.name?.toLowerCase() === p.toLowerCase()))
  );
}, [procedure_, procedureOptions]);

// ✅ Debounced autosave for complaint, history, exam, other
useEffect(() => {
  if (!selectedPatient || !selectedPatient.id) return;

  // ⭐ CRITICAL FIX
  if (!hasEdited || isLoadingDiagnosis) return;

  const saveTimer = setTimeout(async () => {
    try {
      await axios.post(saveOrUpdateDiagnosisdb, {
        patientId: selectedPatient.id,
        dat: selectedPatient.visitDate,
        complaint,
        history,
        exam,
        other,
        currentUser,
      });

      console.log("✅ Auto-saved successfully");
    } catch (error) {
      console.error("❌ Auto-save failed:", error);
    }
  }, 1000);

  return () => clearTimeout(saveTimer);
}, [
  complaint,
  history,
  exam,
  other,
  selectedPatient,
  hasEdited,
  isLoadingDiagnosis   // ⭐ must be dependency
]);


  // Autocomplete now hits the server instead of filtering `allPatients` —
  // the local list only holds the current page (25 rows), so a client-side
  // filter would silently miss patients on other pages.
  const autocompleteReqSeqRef = useRef(0);
  useEffect(() => {
    if (!searchTerm || searchTerm.length < 1) {
      setSearchResults([]);
      setSearchOpen(false);
      return;
    }

    setSearchLoading(true);
    const seq = ++autocompleteReqSeqRef.current;
    const t = setTimeout(async () => {
      try {
        const response = await axios.get(loadAllPatientsToday, {
          params: { page: 0, limit: 20, search: searchTerm },
        });
        if (seq !== autocompleteReqSeqRef.current) return; // stale
        const results = response.data?.success ? response.data.results : [];
        setSearchResults(results);
        setSearchOpen(true);
      } catch (err) {
        console.error('Autocomplete search failed:', err);
        if (seq === autocompleteReqSeqRef.current) setSearchResults([]);
      } finally {
        if (seq === autocompleteReqSeqRef.current) setSearchLoading(false);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [searchTerm]);

const saveServiceProvided = async (
  updateConfirmed = false,
  customType = null,
  customService = null
) => {
  // ✅ Use either passed values or current state
   setLoading(true);
  const finalAttendanceType = customType || attendanceType;
  const finalServiceProvided = customService || serviceProvided;

  // ✅ Keep backup of previous state
  const previousService = serviceProvided;
  const previousType = attendanceType;

  const selectedService = insuredServices.find(
    (s) => s.name === finalServiceProvided
  );

  try {
    const response = await axios.post(saveServiceProvideddb, {
      patient_id: selectedPatient.id,
      dat: selectedPatient.visitDate,
      service_name: finalServiceProvided,
      attendance_type: finalAttendanceType,
      insurance: selectedPatient.insurance,
      code: selectedService?.code || "",
      toup: selectedService?.toup || 0,
      amo: selectedService?.amo || 0,
      unin: selectedService?.unin || 0,
      currentUser,
      patientName: selectedPatient.fullName,
      updateConfirmed,
    });

    // 🔹 When service or attendance already exists for today, auto-update
    //    without asking the user. The old flow popped a confirmation
    //    dialog on every save, which was the main source of the "it
    //    takes a lot of time" complaint — the user has to click through
    //    an extra popup even when they clearly want to update. Just
    //    retry the save with updateConfirmed=true and we're done.
    if (response.data.exists) {
      await saveServiceProvided(true, finalAttendanceType, finalServiceProvided);
      return;
    }

    // No success popup — save silently. The dropdown value staying set
    // is confirmation enough. Errors still surface below.
  } catch (error) {
    console.error("Error saving service:", error);
    Swal.fire("Error", "Unable to save service information.", "error");
  } finally {
    setLoading(false);
  }
};

// ✅ Debounced autosave for complaint, history, exam, other
useEffect(() => {
  if (!autoCalculate) return; // if OFF, skip auto calculation

  // Convert doseAmount to number (it's stored as string from TextField)
  const numericDoseAmount = parseFloat(doseAmount) || 0;

  const nextQty = computeQty({
    doseAmount: numericDoseAmount,
    doseString: dose,
    days,
    frequency,
    doseUnit,
    normalizeFrequencyFn: normalizeFrequency,
    freqMultiplierMap: frequencyMultiplier,
  });
  setQty(nextQty);
}, [doseAmount, dose, days, frequency, doseUnit, autoCalculate]);


// ✅ Save or update diagnosis for a patient
const saveOrUpdateDiagnosis = async (selectedDiagnosesList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save diagnosis.");
    return;
  }

   setLoading(true);

  try {
    const response = await axios.post(saveOrUpdateDiagnosisDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedDiagnoses: selectedDiagnosesList,
      gen:selectedPatient.gender,
      fullName:selectedPatient.fullName,
      age:selectedPatient.age,
      tel:selectedPatient.tel,
      dob: selectedPatient.dob ,
      patientStatus:selectedPatient.state
    });

    if (response.data.success) {
     
    } 
  } catch (error) {
    console.error("❌ Error saving diagnosis:", error);
  }finally {
    setLoading(false);
  }
};

const saveOrUpdateProcedure = async (selectedProceduresList) => {
  if (!selectedPatient || !selectedPatient.id) {
    console.warn("⚠️ No patient selected — cannot save procedures.");
    return;
  }
 setLoading(true);
  try {
    const response = await axios.post(saveOrUpdateProceduresDocumetingdb, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      selectedProcedures: selectedProceduresList,
      gen: selectedPatient.gender,
      fullName: selectedPatient.fullName,
      age: selectedPatient.age,
      tel: selectedPatient.tel,
      dob: selectedPatient.dob,
      patientStatus: selectedPatient.state,
      currentUser: currentUser
    });

    if (response.data.success) {
      
      

      // ✅ CHECK FOR REVERSAL MESSAGES RETURNED BY BACKEND
      if (Array.isArray(response.data.reversals) && response.data.reversals.length > 0) {
        response.data.reversals.forEach((r) => {
         
          ErrorMessage('REVERSAL REQUIRED' ,  `⚠️ REVERSAL REQUIRED\n\nProcedure: ${r.procedure}\nMessage: ${r.message}`)
        });
      }

    } else {
      console.warn("⚠️ Procedure save failed:", response.data.message);
    }

  } catch (error) {
    console.error("❌ Error saving procedures:", error);
  }finally {
    setLoading(false);
  }
};

  // --- AI Analysis logic ---
const analyzeVitals = (vitals) => {
    // Guard against a fully-missing vitals object (patient hasn't been
    // triaged yet — this used to crash the whole screen with
    // "Cannot read properties of null".)
    if (!vitals) return 'No vitals recorded yet.';
    const { temperature, bp, pulse, respiration, bmi } = vitals;
    const temp = parseFloat(temperature);
    // bp may be null / undefined / "" when only some vitals were entered.
    // Split defensively so the analyzer keeps working on whatever fields
    // ARE present instead of blowing up on a missing BP.
    const bpStr = typeof bp === 'string' ? bp : '';
    const [systolic, diastolic] = bpStr.includes('/')
      ? bpStr.split('/').map(Number)
      : [NaN, NaN];
    const pulseNum = parseInt(pulse);
    const respNum = parseInt(respiration);
    const bmiNum = parseFloat(bmi);

    let remarks = [];

    if (temp > 37.5) remarks.push("Slight fever detected");
    else if (temp < 36) remarks.push("Below normal temperature");

    if (systolic > 130 || diastolic > 85)
      remarks.push("Elevated blood pressure");
    else if (systolic < 90 || diastolic < 60)
      remarks.push("Low blood pressure");

    if (pulseNum > 100) remarks.push("High pulse rate");
    else if (pulseNum < 60) remarks.push("Bradycardia (slow heart rate)");

    if (respNum > 20) remarks.push("High respiration rate");

    if (bmiNum > 25) remarks.push("Overweight BMI");
    else if (bmiNum < 18.5) remarks.push("Underweight BMI");

    if (remarks.length === 0)
      remarks.push("All vitals within normal clinical range");

    return remarks.join("; ") + ".";
};


// AI Suggestion State & Logic
const [suggestions, setSuggestions] = useState({});

const handleSuggest = (field, value, ageGroup = "adult") => {
  if (!value.trim()) return;

  // Get the most recent phrase (after comma or period)
  const phrases = value.split(/[.,]/);
  const currentPhrase = phrases[phrases.length - 1].trim();
  if (!currentPhrase) return;

  // Suggestion based on last phrase
  const fieldSuggestions = suggestionsData[field];
  let match =
    fieldSuggestions?.find((item) =>
      item.toLowerCase().includes(currentPhrase.toLowerCase())
    ) || "";

  // Smart diagnosis + procedure inference
  const lower = currentPhrase.toLowerCase();
  const matchedRules = diagnosisRules.filter(
    (rule) =>
      (rule.ageGroup === ageGroup || rule.ageGroup === "both") &&
      rule.keywords.some((k) => lower.includes(k))
  );
  const diagnoses = [...new Set(matchedRules.flatMap((r) => r.possibleDiagnosis))];
  const procedures = [...new Set(matchedRules.flatMap((r) => r.suggestedProcedures))];

  // Update local state
  setSuggestions((prev) => ({
    ...prev,
    [field]: match,
    [`${field}Diagnosis`]: diagnoses,
    [`${field}Procedures`]: procedures,
  }));
};


//Lab

const [labs, setLabs] = useState([]);
const [labSearchTerm, setLabSearchTerm] = useState("");
const [requestedLabs, setRequestedLabs] = useState([]);


const loadLabs = async () => {
  if (!selectedPatient) return;
   setLoading(true);
  try {
    const response = await axios.get(loadLabdb, {
      params: { insurance: selectedPatient.insurance }
    });

    if (response.data.success) { 
      setLabs(response.data.results);

     

    }
  } catch (error) {
    console.error("Failed to load labs:", error);
  }finally {
    setLoading(false);
  }
};



const handleRequestLab = async (lab) => {
  // ✅ Simply check if the same lab exists in today's request list
 
  const alreadyRequested = requestedLabs.some(
    (r) => r.lab === lab.name
  );

  if (alreadyRequested) {
    ErrorMessage(
      "Already Requested",
      `${lab.name} has already been requested today.`
    );
    return;
  }
 setLoading(true);

  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      dat:selectedPatient.visitDate,
      patientInsurance: selectedPatient.insurance,
      labName: lab.name,
      amount: lab.amount,
      base_cost: lab.base_cost,
      code: lab.code,
      currentUser ,
      type:'Lab' ,
      waiting_time: lab.waiting_time
    });

    if (response.data.success) {
      loadRequestedLabs();
    }

  } catch (error) {
    // A stock refusal is not a generic failure: the server sends 409 with
    // code 'OUT_OF_STOCK' and names the consumable that ran out.
    const __stock = error?.response?.data;
    if (error?.response?.status === 409 && __stock?.code === 'OUT_OF_STOCK') {
      ErrorMessage('Out of stock', __stock.message || 'This test cannot be ordered — a consumable has run out.');
      return;
    }
    ErrorMessage("Error", "Failed to request lab");
  }finally {
    setLoading(false);
  }
};


const loadRequestedLabs = async () => {
  if (!selectedPatient || !selectedPatient.id) return;

  setLoading(true);
  try {
    const response = await axios.get(loadRequestedLabsdb, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate
      },
    });

    if (response.data.success) {
      setRequestedLabs(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


const handleDeleteRequest = async (lab) => {
  // ✅ Confirm deletion first
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Lab Request?",
    text: `Are you sure you want to delete "${lab.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });
 
  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: lab.lab,
      dat:selectedPatient.visitDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedLabs();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};



// Available Labs pagination
const [labPage, setLabPage] = useState(0);
const [labRowsPerPage, setLabRowsPerPage] = useState(8);

// Requested Labs pagination
const [reqPage, setReqPage] = useState(0);
const [reqRowsPerPage, setReqRowsPerPage] = useState(8);


//Scan

// Available scans

const [scans, setscans] = useState([]);


const loadAvailableScans = async () => {
  if (!selectedPatient || !selectedPatient.insurance) return;

  setLoading(true);
  try {
    const response = await axios.get(loadAvailableScansdb, {
      params: {
        insurance: selectedPatient.insurance,
      },
    });

    if (response.data.success) {
      setscans(response.data.results);
    }

  } catch (error) {
    console.error("Error loading scans:", error);
  }finally {
    setLoading(false);
  }
};


const loadRequestedScan = async () => {
  if (!selectedPatient || !selectedPatient.id) return;
 setLoading(true);
  try {
    const response = await axios.get(loadRequestedScandb, {
      params: {
        patientId: selectedPatient.id,
        dat:selectedPatient.visitDate,
      },
    });

    if (response.data.success) {
      setRequestedScans(response.data.results);
    }

  } catch (err) {
    console.error("Failed to load requested labs:", err);
  }finally {
    setLoading(false);
  }
};


// Scan Search
const [scanSearchTerm, setScanSearchTerm] = useState("");

// Requested Scans
const [requestedScans, setRequestedScans] = useState([]);

// Pagination for scans
const [scanPage, setScanPage] = useState(0);
const [scanRowsPerPage, setScanRowsPerPage] = useState(8);
const [reqScanPage, setReqScanPage] = useState(0);
const [reqScanRowsPerPage, setReqScanRowsPerPage] = useState(8);

// Request Scan

const handleRequestScan = async (scan) => {

  const alreadyRequested = requestedScans.some(
    (r) => (r.lab || r.scan) === (scan.name || scan.lab)
  );
  if (alreadyRequested) {
    ErrorMessage(
      "Already Requested",
      `${scan.name} has already been requested today.`
    );
    return;
  }
setLoading(true);
  try {
    const response = await axios.post(requestLab, {
      patientId: selectedPatient.id,
      patientInsurance: selectedPatient.insurance,
      labName: scan.name,
      amount: scan.amount,
      base_cost: scan.tariff,
      code: scan.code,
      currentUser ,
      type:'Scan',
      dat:selectedPatient.visitDate,
    });

    if (response.data.success) {
      loadRequestedScan();
    }

  } catch (error) {
    // A stock refusal is not a generic failure: the server sends 409 with
    // code 'OUT_OF_STOCK' and names the consumable that ran out.
    const __stock = error?.response?.data;
    if (error?.response?.status === 409 && __stock?.code === 'OUT_OF_STOCK') {
      ErrorMessage('Out of stock', __stock.message || 'This test cannot be ordered — a consumable has run out.');
      return;
    }
    ErrorMessage("Error", "Failed to request Scan");
  }finally {
    setLoading(false);
  }

 
};

// Delete Scan Request
const handleDeleteScanRequest = async(scan) => {
  setLoading(true);
  //console.log(scan)
  const confirmDelete = await Swal.fire({
    title: "Delete Scan Request?",
    text: `Are you sure you want to delete "${scan.lab}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    
     setLoading(false)
    return; // ✅ User cancelled → STOP
  }

  try {
    const response = await axios.post(deleteRequestedLabdb, {
      patientId: selectedPatient.id,
      labName: scan.lab,
      currentUser ,
      dat:selectedPatient.visitDate,
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadRequestedScan();

  } catch (error) {
    Swal.fire("Error", "Failed to delete lab request", "error");
  }finally {
    setLoading(false);
  }
};

// Medication States
const [medications, setMedications] = useState([]);


const isMedicationChronic = (drugName) => {
  if (!chronicMeds || chronicMeds.length === 0) return false;
  
  // ✅ Normalize the drug name
  const normalizedDrugName = drugName.toLowerCase().trim().replace(/\s+/g, ' ');
  
  return chronicMeds.some(cm => {
    if (!cm || !cm.medication) return false;
    
    const normalizedChronicName = cm.medication.toLowerCase().trim().replace(/\s+/g, ' ');
    
    // ✅ Try exact match first
    if (normalizedChronicName === normalizedDrugName) {
      return true;
    }
    
    // ✅ Try partial match (contains)
    return normalizedDrugName.includes(normalizedChronicName) || 
           normalizedChronicName.includes(normalizedDrugName);
  });
};

// Update loadMedications to accept chronic meds as parameter
/*  Whether the prescriber has asked to see past the age filter. See
 *  MedicationAgeBand.js — a drug hidden by its band must always be reachable,
 *  because the alternative is a medicine that cannot be given at all. */
const [showAllAges, setShowAllAges] = useState(false);
const [medAgeMeta, setMedAgeMeta] = useState(null);

const loadMedications = async (chronicMedsData = null, allAges = showAllAges) => {
  if (!selectedPatient) return;

  setLoading(true);
  try {
    const response = await axios.get(loadMedicationsdb, {
      params: {
        insurance: selectedPatient.insurance,
        patientId: selectedPatient.id,
        //  'all' is the documented opt-out the endpoint has always supported and
        //  no screen ever sent.
        ...(allAges ? { ageCategory: 'all' } : null),
      }
    });
    setMedAgeMeta(response.data);

    if (response.data.success) {
      let meds = response.data.results;

      // ✅ Use passed parameter OR state
      const chronicMedsToUse = chronicMedsData || chronicMeds;

      console.log("📦 Total medications loaded:", meds.length);
      console.log("💊 Chronic meds to use:", chronicMedsToUse);

      // ✅ Sort chronic medications to top
      if (chronicMedsToUse && chronicMedsToUse.length > 0) {
        console.log("🔄 Sorting chronic meds to top...");
        
        const chronicNames = chronicMedsToUse
          .filter(m => m && m.medication)
          .map(m => m.medication.toLowerCase().trim().replace(/\s+/g, ' '));
        
        console.log("Chronic drug names:", chronicNames);

        meds = meds.sort((a, b) => {
          const aName = a && a.name 
            ? a.name.toLowerCase().trim().replace(/\s+/g, ' ')
            : '';
          const bName = b && b.name 
            ? b.name.toLowerCase().trim().replace(/\s+/g, ' ')
            : '';
          
          let aIsChronic = chronicNames.includes(aName);
          let bIsChronic = chronicNames.includes(bName);
          
          if (!aIsChronic) {
            aIsChronic = chronicNames.some(cn => aName.includes(cn) || cn.includes(aName));
          }
          if (!bIsChronic) {
            bIsChronic = chronicNames.some(cn => bName.includes(cn) || cn.includes(bName));
          }
          
          return bIsChronic - aIsChronic;
        });

        console.log("✅ First 5 sorted meds:", meds.slice(0, 5).map(m => m.name));
      }

      setMedications(meds);
    }

  } catch (error) {
    console.error("Failed to load medications:", error);
  } finally {
    setLoading(false);
  }
};

//  Flip the gate and refetch. The band is decided server-side, so this cannot be
//  done by filtering what is already in hand. Chronic meds are passed through so
//  the reload keeps them sorted to the top.
const toggleAllAges = () => {
  const next = !showAllAges;
  setShowAllAges(next);
  setMedPage(0);
  loadMedications(null, next);
};


// 3. ✅ NEW FUNCTION - Handle medication selection with chronic auto-fill
const handleSelectMedication = (med) => {
  setSelectedMed(med);
  
  // ✅ Check if this medication exists in chronic meds with flexible matching
  const chronicMed = chronicMeds && chronicMeds.length > 0 
    ? chronicMeds.find(cm => {
        if (!cm || !cm.medication || !med || !med.name) return false;
        
        const normalizedChronicName = cm.medication.toLowerCase().trim().replace(/\s+/g, ' ');
        const normalizedMedName = med.name.toLowerCase().trim().replace(/\s+/g, ' ');
        
        // Try exact match first
        if (normalizedChronicName === normalizedMedName) {
          return true;
        }
        
        // Try partial match
        return normalizedMedName.includes(normalizedChronicName) || 
               normalizedChronicName.includes(normalizedMedName);
      })
    : null;

  if (chronicMed) {
    // ✅ Auto-fill with chronic medication details
    console.log("✅ Chronic medication found:", chronicMed);
    
    const doseString = chronicMed.dose || "";
    const doseParts = doseString.split(" ");
    setDoseAmount(doseParts[0] || "");
    setDoseUnit(doseParts[1] || "");
    
    setFrequency(chronicMed.freq || "");
    setDays(chronicMed.days || "");
    setQty(chronicMed.qty || 0);
    setRoute(chronicMed.route || "");
    setAutoCalculate(true);
  } else {
    // ✅ Regular flow
    const { medStrength } = extractStrengthFromName(med.name);
    setDoseUnit(medStrength || "");
    setAutoCalculate(isSolidByName(med.name) || isAutoCalcUnit(medStrength));
    
    if (selectedPatient && selectedPatient.age) {
      loadLastMedicationPattern(med.name, selectedPatient.age);
    }
  }
};


// Pagination
const [medPage, setMedPage] = useState(0);
const [medRowsPerPage, setMedRowsPerPage] = useState(10);
const [reqMedPage, setReqMedPage] = useState(0);
const [reqMedRowsPerPage, setReqMedRowsPerPage] = useState(10);
const [medError, setMedError] = useState(false);


// Add medication
const handleAddMedication = async () => {

  // ── Validation ────────────────────────────────────────────────────────────
  let hasError = false;

  if (!selectedMed) {
    ErrorMessage("Error", "Please select a medication first");
    return;
  }
  if (!doseAmount)            { setDoseAmountError(true); hasError = true; }
  if (!frequency)             { setFrequencyError(true);  hasError = true; }
  if (!days || days <= 0)     { setDaysError(true);       hasError = true; }
  if (!route)                 { setRouteError(true);      hasError = true; }
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true); hasError = true;
  }
  if (hasError) return;

  // ── Duplicate prevention ──────────────────────────────────────────────────
  const alreadyRequested = requestedMeds.some(r => r.drug === selectedMed.name);
  if (alreadyRequested) {
    ErrorMessage("Error", `${selectedMed.name} has already been requested today.`);
    return;
  }

  // ── ★ STOCK CHECK ──────────────────────────────────────────────────────
  // Skipped entirely when pharmacy stock control is off in System Settings.
  // Those facilities treat every drug as always in stock, so we don't even
  // spend the round-trip asking. The backend applies the same rule, so this
  // is purely to avoid a pointless call and a dialog that can't be dismissed
  // into a successful submit.
if (stockControlOn) {
  setLoading(true);
  const stockData = await loadMedicationStock(selectedMed.name);
  setLoading(false);

  // check available_qty (stock minus what's already reserved)
  const availableQty = stockData?.available_qty ?? 0;

  if (availableQty < qty) {
    setStockWarningInfo({
      drugName:       selectedMed.name,
      requestedQty:   qty,
      availableStock: availableQty,   // ← shows true available, not total stock
    });
    setStockWarningDialog(true);
    return;
  }
}

  // ── Submit (stock is fine) ────────────────────────────────────────────────
  await submitMedicationRequest();
};


// ═══════════════════════════════════════════════════════════════════════════
// STEP D: Add this new helper function (place it right after handleAddMedication)
//         It contains the actual POST logic, called from both the normal flow
//         and the "Submit Anyway" path in the warning dialog.
// ═══════════════════════════════════════════════════════════════════════════

const submitMedicationRequest = async () => {
  setLoading(true);
  try {
    const response = await axios.post(addMedicationdb, {
      patientId:  selectedPatient.id,
      selectedMed,
      qty,
      frequency,
      route,
      doseAmount,
      days,
      currentUser,
      insurance:  selectedPatient.insurance,
      dat:        selectedPatient.visitDate,
      age:        selectedPatient.age,
    });

    if (response.data.success) {
      loadRequestedMeds();
      handleClearMedication();
      setStockWarningDialog(false);
    }
  } catch (err) {
    /* A stock refusal is not a generic failure. The backend sends
     * code: 'OUT_OF_STOCK' with the quantities and says where the setting
     * lives, so show that instead of "Failed to save medication" — otherwise
     * the doctor cannot tell a stock block from the server being down. */
    const data = err?.response?.data;
    if (err?.response?.status === 409 && data?.code === 'OUT_OF_STOCK') {
      setStockWarningDialog(false);
      ErrorMessage(
        "Out of stock",
        data.message || `${data.item || 'This drug'} is out of stock.`
      );
    } else {
      ErrorMessage("Error", "Failed to save medication");
    }
  } finally {
    setLoading(false);
  }
};


const handleNotifyPharmacy = async () => {
  setNotifyingPharmacy(true);
  try {
    await axios.post(notifyPharmacyRestock, {
      drugName:       stockWarningInfo.drugName,
      requestedQty:   stockWarningInfo.requestedQty,
      availableStock: stockWarningInfo.availableStock,
      patientId:      selectedPatient.id,
      patientName:    selectedPatient.fullName,
      doctorName:     currentUser,
    });

    setStockWarningDialog(false);
    ErrorMessage("Info", "Pharmacy has been notified to restock. Request was not submitted.");
  } catch (err) {
    ErrorMessage("Error", "Failed to notify pharmacy");
  } finally {
    setNotifyingPharmacy(false);
  }
};


const loadRequestedMeds = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadRequestedMedsdb, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, }
    });

    if (response.data.success) {
      setRequestedMeds(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


const handleClearMedication = () => {
  setSelectedMed(null);
  setDoseAmount("");
  setDoseUnit("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");
  setAutoCalculate(true);
  
  // reset errors
  setDoseAmountError(false);
  setFrequencyError(false);
  setDaysError(false);
  setRouteError(false);
  setQtyError(false);
  setMedError(false);

  // ✅ reset editing mode so button goes back to "Make Request"
  setEditingIndex(null);
};

 
// Delete medication
const handleDeleteMedication = async (med) => {
  //console.log(med);

  // 1️⃣ Confirm delete
  setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Medication?",
    text: `Are you sure you want to delete "${med.drug || "this medication"}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
     setLoading(false)
     return
  }  // user cancelled
  try {
    // 2️⃣ Send delete request (POST)
    const response = await axios.post(medicationdeletedb, {
      trans_code: med.trans_code,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:selectedPatient.visitDate,
    });

    // 3️⃣ If backend says reversal required
    if (response.data.reversalRequired) {
      Swal.fire(
        "REVERSAL REQUIRED",
        response.data.message ||
          "This medication has already been paid for. Refund/reversal is required.",
        "warning"
      );
      return;
    }

    // 4️⃣ Successful deletion
    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadRequestedMeds(); // refresh table
      return;
    }

    // 5️⃣ Backend returned an error
    Swal.fire(
      "Error",
      response.data.message || "Could not delete medication.",
      "error"
    );

  } catch (error) {
    console.error("DELETE MEDICATION ERROR:", error);
    Swal.fire("Error", "Something went wrong.", "error");
  }finally {
    setLoading(false);
  }
};


// Edit medication
const [editingIndex, setEditingIndex] = useState(null);
const [EditMad , setEditMad] =useState()

const handleEditMedication = (idx) => {
  const med = requestedMeds[idx];

  setEditMad(med)
  setSelectedMed({ name: med.drug });
  setDoseAmount(med.dose.split(" ")[0]);
  setDoseUnit(med.dose.split(" ")[1] || "");
  setFrequency(med.freq);
  setDays(med.days);
  setQty(med.qty);
  setRoute(med.route);
  setAutoCalculate(true);
  setEditingIndex(idx); // mark edit mode
};


const handleUpdateMedication = async () => {
  if (!EditMad || !EditMad.trans_code) {
    ErrorMessage("Error", "No medication selected for update.");
    return;
  }

  let hasError = false;

  if (!doseAmount) {
    setDoseAmountError(true);
    hasError = true;
  }
  if (!frequency) {
    setFrequencyError(true);
    hasError = true;
  }
  if (!days || days <= 0) {
    setDaysError(true);
    hasError = true;
  }
  if (!route) {
    setRouteError(true);
    hasError = true;
  }
  if ((!autoCalculate && (!qty || qty <= 0)) || (autoCalculate && qty <= 0)) {
    setQtyError(true);
    hasError = true;
  }

  if (hasError) return;

  setLoading(false);
  try {
    const response = await axios.post(updateMedicationdb, {
      trans_code: EditMad.trans_code, // ✅ identify the record
      doseAmount,
      frequency,
      days,
      route,
      qty,
      currentUser,
      patientId: selectedPatient.id,
      insurance: selectedPatient.insurance,
      dat:selectedPatient.visitDate,
    });

    if (response.data.success) {
      successMessage("Success", "Medication updated successfully");
      loadRequestedMeds();  // reload data
      handleClearMedication();
    } else {
      ErrorMessage("Error", response.data.message || "Failed to update medication");
    }
  } catch (error) {
    ErrorMessage("Error", "Unable to update medication");
    console.error("Update medication error:", error);
  }finally {
    setLoading(false);
  }
};


const loadMedicationStock = async (medicationName) => {
  try {
    const response = await axios.get(medicationStock, {
      params: { name: medicationName }
    });
    
    if (response.data.success) {
      return response.data.stock;
    }
    return null;
  } catch (error) {
    console.error("Error loading medication stock:", error);
    return null;
  }
};

const handleMedicationInfo = async (med) => {
  setMedInfoLoading(true); // ✅ Start loading
  setSelectedMedInfo(med); // ✅ Set basic info immediately
  setMedInfoDialogOpen(true); // ✅ Open dialog
  
  try {
    const stockInfo = await loadMedicationStock(med.name);
    setSelectedMedInfo({ ...med, ...stockInfo }); // ✅ Update with stock info
  } catch (error) {
    console.error("Error loading stock:", error);
    ErrorMessage("Error", "Failed to load stock information");
  } finally {
    setMedInfoLoading(false); // ✅ Stop loading
  }
};


const [medDialogOpen, setMedDialogOpen] = useState(false);

// Helper function
const normalizeFrequency = (freq) => {
  if (!freq) return "";
  return frequencyMap[freq.toLowerCase().trim()] || freq;
};


const autoCalcUnits = [
  "tab", "tablet",
  "cap", "capsule",
  "pill", "lozenge", "suppository",
  "amp", "vial"
];

const isAutoCalcUnit = (unit = "") => {
  return autoCalcUnits.some(u => unit.toLowerCase().includes(u));
};

const solidKeywords = ["tablet", "tab", "capsule", "cap", "pill", "lozenge", "suppository"];
const isSolidByName = (name = "") => {
  return solidKeywords.some(k => name.toLowerCase().includes(k));
};


// Unicode fraction mapping
const FRACTION_MAP = { "¼": 0.25, "½": 0.5, "¾": 0.75 };
const normalizeUnicodeFractions = (s) =>
  String(s || "").replace(/[¼½¾]/g, (m) => String(FRACTION_MAP[m] ?? m));

/** Extract numeric part from a dose string like "500ml", "1/2 tab", "½ cap", "5 mg" */
const parseDoseNumber = (doseStr) => {
  if (!doseStr) return 0;
  const cleaned = normalizeUnicodeFractions(doseStr).trim().toLowerCase();
  // match number (int/decimal or fraction) at the start
  const m = cleaned.match(/^(\d+(?:\.\d+)?|\d+\/\d+)/);
  if (!m) return 0;
  if (m[1].includes("/")) {
    const [a, b] = m[1].split("/").map(Number);
    return b ? a / b : Number(m[1]) || 0;
  }
  return parseFloat(m[1]) || 0;
};

/** Compute quantity from either split doseAmount or free-text dose */
const computeQty = ({
  doseAmount,
  doseString,
  days,
  frequency,
  doseUnit,
  normalizeFrequencyFn,
  freqMultiplierMap
}) => {
  const normalized = normalizeFrequencyFn(frequency || "");
  const perDay = freqMultiplierMap[normalized] ?? 1;

  const amount =
    typeof doseAmount === "number" && !isNaN(doseAmount)
      ? doseAmount
      : parseDoseNumber(doseString);

  if (!amount || !Number(days)) return 0;

  // ✅ Same formula for liquids and solids
  // Quantity = dose × frequency per day × number of days
  return Math.ceil(Number(amount) * Number(perDay) * Number(days));
};



const loadLastMedicationPattern = async (selectedMedName, patientAge) => {
  try {
    const ageGroup = patientAge >= 12 ? "adult" : "child";

    const res = await axios.get(loadMedicationByAge, {
      params: { name: selectedMedName, age:ageGroup }
    });

    if (res.data.success) {
      const p = res.data.med;

      // 🔥 Auto-fill only if backend found data
      setDoseAmount(p.dose);
      setFrequency(p.freq);
      setDays(p.day_server);
      setRoute(p.rou);
      setQty(p.qua);

      
    }else {
      setDoseAmount('');
      setFrequency('');
      setDays('');
      setRoute('');
      setQty('');
    }
  } catch (error) {
    console.log("Error loading medication pattern:", error);
  }
};



const extractStrengthFromName = (name) => {
  if (!name) return { medName: "", medStrength: "" };

  loadLastMedicationPattern(name, selectedPatient.age);

  let medName = name.trim();
  let medStrength = "";

  // Case 1: If there is a comma, assume strength is after the last comma
  if (name.includes(",")) {
    const parts = name.split(",");
    medName = parts.slice(0, -1).join(",").trim();
    medStrength = parts[parts.length - 1].trim();
  } else {
    // Case 2: If it ends with (...) → treat last parentheses as strength
    const parenMatch = name.match(/^(.*)\(([^()]*)\)\s*$/);
    if (parenMatch) {
      medName = parenMatch[1].trim();
      medStrength = parenMatch[2].trim();
    } else {
      // Case 3: Try to match trailing numeric + unit like "80mg/mL", "0.5%", "125mls"
      const match = name.match(/(.*?)(\d+(?:\.\d+)?\s?(?:mg\/ml|mg|g|mcg|ml|mls|%|units?|iu))$/i);
      if (match) {
        medName = match[1].trim();
        medStrength = match[2].trim();
      }
    }
  }

  return { medName, medStrength };

  
};


const [doseAmountError, setDoseAmountError] = useState(false);
const [frequencyError, setFrequencyError] = useState(false);
const [daysError, setDaysError] = useState(false);
const [routeError, setRouteError] = useState(false);
const [qtyError, setQtyError] = useState(false);


const handleChronicRefill = async (med) => {
  Swal.fire({
    title: "Chronic Medication Refill?",
    text: `Refill ${med.drug} for this patient?`,
    showCancelButton: true,
    confirmButtonText: "Yes, Refill",
    cancelButtonText: "Cancel",
    icon: "info"
  }).then(async (result) => {
    if (!result.isConfirmed) return;

    try {
      // Save or update chronic medication
      const response =await axios.post(saveChronicMedication, {
        patientId: selectedPatient.id,
        drug: med.drug,
        dose: med.dose,
        freq: med.freq,
        days: med.days,
        qty: med.qty,
        route: med.route,
        doctor: currentUser
      });


      if (response.data.success) {
      successMessage("Success", "Chronic medication saved successfully");
    } else {
      ErrorMessage("Error", response.data.message || "Failed to Save Chronic medication");
    }
    } catch (error) {
      Swal.fire("Error", "Failed to save chronic medication", "error");
      return;
    }

  });
};


//Other Services

// --- Other Services: sample list ---

const [services, setservices] = useState([]);
const [serviceQuantities, setServiceQuantities] = useState({});

const loadOtherServices = async () => {
   setLoading(true);
  try {
    const response = await axios.get(loadOtherServicesdb, {
      params: {
        charge_status: "Manual",
      }
    });

    if (response.data.success) {
      setservices(response.data.results);
    } else {
      setservices([]);
    }

  } catch (error) {
    console.error("Failed to load other services:", error);
    setservices([]);
  }finally {
    setLoading(false);
  }
};


// Search
const [serviceSearchTerm, setServiceSearchTerm] = useState("");

// Requested Services
const [requestedServices, setRequestedServices] = useState([]);

const loadrequestedServices = async () => {
   setLoading(false);
  try {
    const response = await axios.get(loadRequestedOtherServicesdb, {
      params: { patientId: selectedPatient.id , dat:selectedPatient.visitDate, }
    });

    if (response.data.success) {
      setRequestedServices(response.data.results);
    }
  } catch (err) {
    console.error("Error loading meds:", err);
  }finally {
    setLoading(false);
  }
};


// Pagination
const [servicePage, setServicePage] = useState(0);
const [serviceRowsPerPage, setServiceRowsPerPage] = useState(8);
const [reqServicePage, setReqServicePage] = useState(0);
const [reqServiceRowsPerPage, setReqServiceRowsPerPage] = useState(8);


// Request a service (prevents duplicate request on the same day)
const handleRequestService = async(srv) => {

  const existsToday = requestedServices.some(
    (r) => r.service === srv.name) 
  if (existsToday) {
    ErrorMessage('"Already Requested",' ,`${srv.name} has already been requested today.`);
    return;
  }

   setLoading(true);
    try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat:selectedPatient.visitDate,
      charge: srv.name,
      amount: srv.amount,
      doc_name:currentUser,
      from_user:currentUser,
      name:selectedPatient.fullName,
      department:'Doctor'
    });

    if (response.data.success) {
      loadrequestedServices();
    }

  } catch (error) {
    ErrorMessage("Error", "Failed to request Non Insured Services ");
  }finally {
    setLoading(false);
  }

 // setRequestedServices((prev) => [...prev, newReq]);
}; 



// Delete a requested service (allowed only if Pending in UI)
const handleDeleteServiceRequest = async (req) => {
  // ✅ Confirm deletion first
 
   setLoading(true);
  const confirmDelete = await Swal.fire({
    title: "Delete Other Request?",
    text: `Are you sure you want to delete "${req.service}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) {
    setLoading(false)
    return; 
  }

   try {
    const response = await axios.post(deleteOrReverseOtherServicedb, {
      patientId: selectedPatient.id,
      scanName: req.service,
      dat:selectedPatient.visitDate,
      currentUser
    });

    // ✅ If backend returns reversal warning
    if (response.data.reversal) {
      ErrorMessage("REVERSAL REQUIRED", response.data.reversal);
    } else {
      Swal.fire("Deleted", response.data.message, "success");
    }

    // ✅ Refresh the table
    loadrequestedServices();

  } catch (error) {
    Swal.fire("Error", "Failed to delete Other request", "error");
  }finally {
    setLoading(false);
  }
};


const handleManualServiceRequest = async () => {
  if (!manualServiceName || !manualAmount) {
    ErrorMessage("Missing info", "Enter service name and amount");
    return;
  }

  // prevent duplicate same-day request
  const existsToday = requestedServices.some(
    r => r.service.toLowerCase() === manualServiceName.toLowerCase()
  );

  if (existsToday) {
    ErrorMessage("Already Requested", "Service already requested today");
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(requestOtherService, {
      patientId: selectedPatient.id,
      dat: selectedPatient.visitDate,
      charge: manualServiceName,
      amount: Number(manualAmount) * Number(manualQty),
      doc_name: currentUser,
      from_user: currentUser,
      name: selectedPatient.fullName,
      department: "Doctor"
    });

    if (response.data.success) {
      loadrequestedServices();

      // clear fields
      setManualServiceName("");
      setManualQty(1);
      setManualAmount("");
    }
  } catch (err) {
    ErrorMessage("Error", "Failed to request service");
  } finally {
    setLoading(false);
  }
};


// Appointment

const [editingAppointmentId, setEditingAppointmentId] = useState(null);

// Load appointments
const [appointments, setAppointments] = useState([]);

const loadAppointments = async () => {
  try {
     setLoading(true);
    const response = await axios.get(loadAppointmentsdb, {
      params: { 
        patientId: selectedPatient?.id,
        doctorName: currentUser 
      }
    });

    if (response.data.success) {
      console.log(response.data.appointments)
      setAppointments(response.data.appointments || []);
    }
  } catch (error) {
    console.error("Error loading appointments:", error);
    ErrorMessage("Error", "Failed to load appointments");
  }finally {
    setLoading(false);
  }
};



// ✅ ADD THIS FUNCTION in OutPatient.jsx
const scheduleAppointmentSMS = async (appointmentDate, appointmentTime, appointmentType) => {
  try {
    const response = await axios.post(scheduleAppointmentSms, {
      tel: selectedPatient.tel,
      patientName: selectedPatient.fullName,
      appointmentDate,
      appointmentTime,
      appointmentType
    });

    if (response.data.success) {
      console.log('✅ SMS scheduled:', response.data.message);
    } else {
      console.warn('⚠️ SMS scheduling failed:', response.data.message);
    }
  } catch (error) {
    console.error('❌ Failed to schedule SMS:', error);
  }
};


// Save appointment
const handleSaveAppointment = async () => {
  if (!selectedPatient || !appointmentDate || !appointmentTime || !appointmentType) {
    ErrorMessage("Error", "Please complete all required fields.");
    return;
  }

  setLoading(true);
  try {
    if (editingAppointmentId) {
      const response = await axios.post(updateAppointmentdb, {
        appointmentId: editingAppointmentId,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder
      });

      if (response.data.success) {
        successMessage("Success", "Appointment updated successfully");
        loadAppointments();
        handleClearAppointmentForm();

        // ✅ Schedule SMS on update if reminder checked
        if (sendReminder) {
          await scheduleAppointmentSMS(appointmentDate, appointmentTime, appointmentType);
          Swal.fire({
            icon: 'success',
            title: 'Reminder Scheduled',
            text: `SMS reminder scheduled for ${selectedPatient.fullName} on ${appointmentDate} at ${appointmentTime}`,
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        ErrorMessage("Error", response.data.message);
      }

    } else {
      const response = await axios.post(saveAppointmentdb, {
        patientId: selectedPatient.id,
        patientName: selectedPatient.fullName,
        patientTel: selectedPatient.tel,
        appointmentDate,
        appointmentTime,
        appointmentType,
        reason: appointmentReason,
        otherInfo: appointmentOther,
        sendReminder,
        currentUser
      });

      if (response.data.success) {
        successMessage("Success", "Appointment saved successfully");
        loadAppointments();

        // ✅ Schedule SMS on new save if reminder checked
        if (sendReminder) {
          await scheduleAppointmentSMS(appointmentDate, appointmentTime, appointmentType);
          Swal.fire({
            icon: 'success',
            title: 'Reminder Scheduled',
            text: `SMS reminder scheduled for ${selectedPatient.fullName} on ${appointmentDate} at ${appointmentTime}`,
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        ErrorMessage("Error", response.data.message);
      }
    }
  } catch (error) {
    console.error("Error saving appointment:", error);
    ErrorMessage("Error", "Failed to save appointment");
  } finally {
    setLoading(false);
  }
};

// Clear form
const handleClearAppointmentForm = () => {
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);
};



// Delete appointment
const handleDeleteAppointment = async (editingAppointmentId) => {
  
  if (!editingAppointmentId) return;

  const confirmDelete = await Swal.fire({
    title: "Delete Appointment?",
    text: `Are you sure you want to delete this appointment for ${editingAppointmentId}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "No, cancel",
  });

  if (!confirmDelete.isConfirmed) return;

   setLoading(true);
  try {
    const response = await axios.post(deleteAppointmentdb, {
      appointmentId: editingAppointmentId
    });

    if (response.data.success) {
      Swal.fire("Deleted", response.data.message, "success");
      loadAppointments();
      handleClearAppointmentForm()
    } else {
      ErrorMessage("Error", response.data.message);
    }
  } catch (error) {
    console.error("Error deleting appointment:", error);
    ErrorMessage("Error", "Failed to delete appointment");
  }finally {
    setLoading(false);
  }
};


const loadPatientAppointments = async () => {
  setLoading(true);
  try {
    const res = await axios.get(getPatientAppointmentdb, {
      params: { patientId: selectedPatient.id }
    });

    if (res.data.success) {
      const allAppointments = res.data.appointments || [];

      // Update list stored in state
      setAppointments(allAppointments);

      // If no upcoming appointment → reset form
      if (allAppointments.length === 0) {
        setAppointmentDate("");
        setAppointmentTime("");
        setAppointmentType("");
        setAppointmentReason("");
        setAppointmentOther("");
        setSendReminder(false);
        setEditingAppointmentId(null);
        return;
      }

      // Get the nearest appointment
      const nextAppointment = allAppointments[0];

      setAppointmentDate(nextAppointment.date);
      setAppointmentTime(nextAppointment.time);
      setAppointmentType(nextAppointment.type);
      setAppointmentReason(nextAppointment.reason || "");
      setAppointmentOther(nextAppointment.other_info || "");
      setSendReminder(nextAppointment.send_reminder === 1);
      setEditingAppointmentId(nextAppointment.id);

      console.log("Loaded appointment:", nextAppointment);
    }
  } catch (error) {
    ErrorMessage("Error loading appointments:", error);
  }finally {
    setLoading(false);
  }
};



const [selectedDiagnoses, setSelectedDiagnoses] = useState([]);
const [selectedProcedures, setSelectedProcedures] = useState([]);
const [admissionStatus, setAdmissionStatus] = useState("");



const [appointmentDate, setAppointmentDate] = useState("");
const [appointmentTime, setAppointmentTime] = useState("");
const [appointmentType, setAppointmentType] = useState("");
const [appointmentReason, setAppointmentReason] = useState("");
const [appointmentOther, setAppointmentOther] = useState("");
const [sendReminder, setSendReminder] = useState(false);

// Unified search
const [filterSearch, setFilterSearch] = useState("");


const filteredAppointments = appointments.filter((a) => {
  const query = filterSearch.toLowerCase();
  return (
    a.patient_name.toLowerCase().includes(query) ||
    a.id.toLowerCase().includes(query) ||
    a.type.toLowerCase().includes(query) ||
    a.date.includes(query)
  );
});


//admit 

const [admissionDate, setAdmissionDate] = useState(() => new Date().toISOString().split("T")[0]);
const [admissionTime, setAdmissionTime] = useState(() => {
  const now = new Date();
  return now.toTimeString().slice(0, 5);
});
const [admissionNote, setAdmissionNote] = useState("");
const [treatmentPlan, setTreatmentPlan] = useState("");


const validateAdmissionForm = () => {
  if (!admissionStatus) {
    ErrorMessage("Missing Field", "Please select Admission Status");
    return false;
  }

  if (!admissionDate) {
    ErrorMessage("Missing Field", "Please select Date of Admission");
    return false;
  }

  if (!admissionTime) {
    ErrorMessage("Missing Field", "Please select Time of Admission");
    return false;
  }

  if (!admissionNote.trim()) {
    ErrorMessage("Missing Field", "Admission Note cannot be empty");
    return false;
  }

  if (!treatmentPlan.trim()) {
    ErrorMessage("Missing Field", "Treatment Plan cannot be empty");
    return false;
  }

  return true;
};


const submitAdmission = async () => {
  // Ask user if they want to proceed with admission
  const confirmResult = await Swal.fire({
    title: 'Confirm Admission',
    html: `
      <div style="text-align: left;">
        <p><strong>Patient:</strong> ${selectedPatient.fullName}</p>
        <p><strong>Admission Status:</strong> ${admissionStatus}</p>
        <p><strong>Date:</strong> ${moment(`${admissionDate} ${admissionTime}`).format('DD/MM/YYYY hh:mm A')}</p>
        <br/>
        <p style="font-weight: 600;">Do you want to proceed with this admission?</p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Admit Patient',
    cancelButtonText: 'No, Cancel'
  });

  // If user clicks "No" or closes dialog, do nothing
  if (!confirmResult.isConfirmed) {
    return;
  }

  // User clicked "Yes", proceed with admission
  setLoading(true);
  try {
    const res = await axios.post(admitPatient, {
      patientId: selectedPatient.id,
      admissionStatus,
      admissionDate,
      admissionTime,
      admissionNote,
      treatmentPlan,
      dat: selectedPatient.visitDate,
      insu: selectedPatient.insurance,
      name: selectedPatient.fullName,
      age: selectedPatient.age,
      gender: selectedPatient.gender,
      currentUser,
      complaint,
      exam,
      other,
      Diagnosis,
      procedure_
    });

    if (res.data.success) {
      Swal.fire({
        icon: "success",
        title: "Patient Admitted",
        text: "Patient admitted successfully.",
        timer: 2000,
        showConfirmButton: false
      });

      // Reset form after success
      setAdmissionStatus("");
      setAdmissionDate("");
      setAdmissionTime("");
      setAdmissionNote("");
      setTreatmentPlan("");
      setActiveTab(0);
      loadPatients();
      clearSelectedPatientData();
    } else {
      Swal.fire("Error", res.data.message, "error");
    }

  } catch (err) {
    /*  The server explains WHY an admission was refused — "already has an open
     *  admission from 2026-03-30 … probably never closed, discharge it from the
     *  ward list and then admit again", or which patient is in the bed. axios
     *  throws on 4xx as well as 5xx, so a refusal lands here, and this used to
     *  replace all of it with the constant "Failed to admit patient."
     *
     *  A doctor reading that has no way to tell a five-month-old unclosed
     *  admission from a dead database, when the fix was one discharge away.
     *
     *  A refusal (409/404) is shown as a warning with the server's own sentence.
     *  Only a genuine fault keeps the generic line, because a clinician cannot
     *  act on a stack trace.
     */
    const refused = err?.response?.data?.refused;
    const serverMsg = err?.response?.data?.message;

    Swal.fire({
      icon: refused ? 'warning' : 'error',
      title: refused ? 'Cannot admit yet' : 'Error',
      text: (refused && serverMsg) ? serverMsg : 'Failed to admit patient.',
      confirmButtonText: 'OK',
    });
    console.error(err);
  } finally {
    setLoading(false);
  }
};


const clearSelectedPatientData = () => {
  setSelectedPatient(null);
  setSearchTerm("");
  setSearchOpen(false);
  setSearchResults([]);
  setActiveTab(0);

  // Clear diagnosis fields
  setComplaint("");
  setHistory("");
  setExam("");
  setOther("");
  setSelectedDiagnoses([]);
  setSelectedProcedures([]);

  // Clear services
  setServiceProvided("");
  setAttendanceType("");

  // Clear labs
  setLabs([]);
  setRequestedLabs([]);

  // Clear scans
  setscans([]);
  setRequestedScans([]);

  // Clear medications
  setMedications([]);
  setRequestedMeds([]);
  setSelectedMed(null);
  setDose("");
  setFrequency("");
  setDays("");
  setQty(0);
  setRoute("");

  // Clear appointments
  setAppointments([]);
  setAppointmentDate("");
  setAppointmentTime("");
  setAppointmentType("");
  setAppointmentReason("");
  setAppointmentOther("");
  setSendReminder(false);
  setEditingAppointmentId(null);

  // Clear other services
  setservices([]);
  setRequestedServices([]);

  console.log("All patient data cleared!");
};




  return (
  <Box sx={{
  bgcolor: "#f5f5f5",
  minHeight: "100vh",
  p: 1.5,
  '& .MuiTypography-h4': { fontSize: '1.2rem' },
  '& .MuiTypography-h5': { fontSize: '1.05rem' },
  '& .MuiTypography-h6': { fontSize: '0.95rem', fontWeight: 700 },
  '& .MuiCardContent-root': { padding: '12px', '&:last-child': { paddingBottom: '12px' } },
  '& .MuiButton-sizeMedium': {
    paddingTop: '4px', paddingBottom: '4px',
    paddingLeft: '10px', paddingRight: '10px',
    fontSize: '0.78rem', minHeight: '30px',
  },
  '& .MuiButton-sizeSmall': {
    paddingTop: '2px', paddingBottom: '2px',
    paddingLeft: '8px', paddingRight: '8px',
    fontSize: '0.75rem', minHeight: '26px',
  },
  '& .MuiTab-root': { minHeight: 38 },
  '& .MuiTabs-root': { minHeight: 38 },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0.7)'
    },
    '50%': {
      transform: 'scale(1.05)',
      boxShadow: '0 0 0 10px rgba(255, 152, 0, 0)'
    },
    '100%': {
      transform: 'scale(1)',
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0)'
    }
  }
}}>
      {loading && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          bgcolor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(2px)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <CircularProgress size={70} thickness={5} />
      </Box>
)}

  <Container maxWidth="xl">
        {/* ── PATIENT WORKLIST TABLE — shown when no patient is selected ── */}
        {!selectedPatient && (
          <PatientTable
            patients={allPatients}
            onSelectPatient={setSelectedPatient}
            currentUser={currentUser}
            variant="outpatient"
            serverSide
            totalCount={worklistTotal}
            page={worklistPage}
            rowsPerPage={worklistRowsPerPage}
            search={worklistSearch}
            orderBy={worklistOrderBy}
            order={worklistOrder}
            onQueryChange={({ page, rowsPerPage, search, orderBy, order }) => {
              if (page       !== undefined) setWorklistPage(page);
              if (rowsPerPage!== undefined) setWorklistRowsPerPage(rowsPerPage);
              if (search     !== undefined) setWorklistSearch(search);
              if (orderBy    !== undefined) setWorklistOrderBy(orderBy);
              if (order      !== undefined) setWorklistOrder(order);
            }}
          />
        )}

        {/* ── PATIENT WORKSPACE — shown when a patient is selected ── */}
        {selectedPatient && (
        <>
        {/* Slim patient header bar with Back + Prev/Next */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2.5,
          flexWrap: 'wrap',
          gap: 2,
        }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Tooltip title="Back to patient list" arrow>
              <IconButton
                onClick={() => { setSelectedPatient(null); setSearchTerm(''); }}
                size="small"
                sx={{
                  bgcolor: 'rgba(26,155,127,0.10)',
                  color: '#1A9B7F',
                  '&:hover': { bgcolor: 'rgba(26,155,127,0.18)' },
                }}
              >
                <ArrowBack sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
            <Box>
              <Typography sx={{
                fontSize: '0.7rem', fontWeight: 700,
                color: '#1A9B7F', letterSpacing: '1.2px', textTransform: 'uppercase',
              }}>
                OutPatient Consultation
              </Typography>
              <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.25 }}>
                {selectedPatient.fullName}
                <Box component="span" sx={{ fontWeight: 500, color: '#64748b', fontSize: '0.85rem', ml: 1 }}>
                  · ID {selectedPatient.id}
                </Box>
              </Typography>
            </Box>
          </Stack>

          {currentPatientIndex >= 0 && allPatients.length > 1 && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{
                bgcolor: '#fff',
                border: '1px solid #e5e9ef',
                borderRadius: 1.75,
                px: 0.5,
                py: 0.25,
              }}
            >
              <Tooltip title={hasPrevPatient ? 'Previous patient (←)' : 'No previous patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToPrevPatient}
                    disabled={!hasPrevPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowBackIosNew sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>

              <Box sx={{
                px: 1.25, minWidth: 78, textAlign: 'center',
                borderLeft: '1px solid #f1f5f9',
                borderRight: '1px solid #f1f5f9',
              }}>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.1 }}>
                  {currentPatientIndex + 1}
                  <Box component="span" sx={{ color: '#94a3b8', fontWeight: 500, mx: 0.4 }}>
                    of
                  </Box>
                  {allPatients.length}
                </Typography>
                <Typography sx={{ fontSize: '0.62rem', color: '#94a3b8', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                  Patient
                </Typography>
              </Box>

              <Tooltip title={hasNextPatient ? 'Next patient (→)' : 'No next patient'} arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={goToNextPatient}
                    disabled={!hasNextPatient}
                    sx={{
                      color: '#1A9B7F',
                      '&.Mui-disabled': { color: '#cbd5e1' },
                      '&:hover': { bgcolor: 'rgba(26,155,127,0.10)' },
                    }}
                  >
                    <ArrowForwardIos sx={{ fontSize: 14 }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          )}
        </Box>

        {/* --- Patient Search Box --- */}
    <Paper sx={{ p: 2, mb: 3 }}>
      <Autocomplete
        fullWidth
        freeSolo
        open={searchOpen}
        onOpen={() => {
          if (searchResults.length > 0 && searchTerm.length > 0)
            setSearchOpen(true);
        }}
        onClose={() => setSearchOpen(false)}
        inputValue={searchTerm}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
          if (newInputValue.length < 1) {
            setSearchOpen(false);
            setSearchResults([]);
          }
        }}
        options={searchResults}
        loading={searchLoading}
        getOptionLabel={(option) => `${option.fullName} (${option.id})`}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
              onClick={() => {
              clearSelectedPatientData();   // 🔥 reset everything
              setSelectedPatient(option);  // then load new patient
              setSearchOpen(false);
            }}
            sx={{
              borderBottom: "1px solid",
              borderColor: "divider",
              "&:last-child": { borderBottom: "none" },
              p: 2,
              cursor: "pointer",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <Box display="flex" alignItems="center" gap={2} width="100%">
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <Person />
              </Avatar>
              <Box flex={1}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {option.fullName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ID: {option.id}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                  <Chip
                    size="small"
                    label={option.gender}
                    color={option.gender === "MALE" ? "info" : "error"}
                  />
                  <Chip size="small" label={option.insurance} />
                  <Chip
                    size="small"
                    label={option.state}
                    color={
                      option.state === "inPatient" ? "success" : "warning"
                    }
                  />
                </Stack>
              </Box>
              <Box textAlign="right">
                <Typography variant="body2" color="text.secondary">
                  {option.tel}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Age: {formatAge(option.dob, option.age)}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search patient by ID, Name"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <Search sx={{ color: "action.active", mr: 1 }} />
              ),
              endAdornment: (
                <>
                  {searchLoading ? (
                    <CircularProgress color="inherit" size={25} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Paper>

       
{/* Sentinel for the IntersectionObserver — drives auto collapse/expand */}
{selectedPatient && (
  <Box ref={bannerSentinelRef} sx={{ height: 1, mb: 0 }} />
)}

{/* Slim sticky strip — shown when banner is collapsed */}
{selectedPatient && bannerCollapsed && (
  <Box
    onClick={() => { setBannerCollapsed(false); setBannerManual(true); }}
    sx={{
      position: 'sticky', top: 0, zIndex: 50,
      mb: 1, mx: -1.5, px: 1.5, py: 0.75,
      bgcolor: '#fff', borderBottom: '1px solid #e5e9ef',
      boxShadow: '0 2px 6px rgba(15,23,42,0.04)',
      display: 'flex', alignItems: 'center', gap: 1.25,
      cursor: 'pointer', transition: 'background-color .15s ease',
      '&:hover': { bgcolor: '#f8fafc' },
    }}
  >
    <Avatar sx={{
      width: 28, height: 28, fontSize: 12, fontWeight: 700,
      bgcolor: '#1A9B7F', color: '#fff',
    }}>
      {(selectedPatient.fullName || '?').split(/\s+/).slice(0,2).map(s => s[0]).join('').toUpperCase()}
    </Avatar>
    <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', flex: 1, minWidth: 0 }} noWrap>
      {selectedPatient.fullName}
      <Box component="span" sx={{ color: '#64748b', fontWeight: 500, ml: 0.75 }}>· {selectedPatient.id}</Box>
    </Typography>
    <IconButton size="small" sx={{ color: '#1A9B7F' }}>
      <KeyboardArrowDown />
    </IconButton>
  </Box>
)}

{/* --- Enhanced Patient Info Card --- */}
{selectedPatient && (
  <Collapse in={!bannerCollapsed} timeout={220}>
  <Card
    sx={{
      mb: 1.5,
      boxShadow: '0 2px 10px rgba(15,23,42,0.06)',
      borderRadius: 2,
      overflow: 'hidden',
      position: 'relative',
    }}
  >
    {/* Manual collapse toggle — top-right of the banner */}
    <IconButton
      size="small"
      onClick={() => { setBannerCollapsed(true); setBannerManual(true); }}
      sx={{
        position: 'absolute', top: 6, right: 6, zIndex: 6,
        bgcolor: 'rgba(15,23,42,0.04)', color: '#475569',
        '&:hover': { bgcolor: 'rgba(15,23,42,0.10)' },
      }}
    >
      <KeyboardArrowUp />
    </IconButton>
    {/* Header Section with Gradient Background */}
    <PatientHeaderCard
      patient={selectedPatient}
      statusLabel={selectedPatient.state}
      ageText={formatAge(selectedPatient.dob, selectedPatient.age)}
      onPrecaution={() => setPrecautionDialogOpen(true)}
      onVitalsHistory={() => setVitalsHistoryOpen(true)}
    />

    {/* Body Section - Full Vital Signs Details */}
   <CardContent>
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
   

    {/* AI Analysis Section - Full Width Below */}
    <Grid item xs={12} size={12}>
      <Box
        sx={{
          p: 2.5,
          background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
          borderRadius: 2,
          border: '2px solid #90caf9',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <AutoAwesome 
          sx={{ 
            color: 'primary.main',
            fontSize: 28,
            mt: 0.5
          }} 
        />
        <Box flex={1}>
          <Typography 
            variant="subtitle1" 
            fontWeight={700}
            color="primary"
            sx={{ mb: 1 }}
          >
            AI-Powered Analysis
          </Typography>
          <Typography 
            variant="body2"
            sx={{ 
              lineHeight: 1.7,
              color: 'text.primary'
            }}
          >
           {selectedPatient?.vitals ? analyzeVitals(selectedPatient.vitals) : "No vitals data available"}
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>
</CardContent>
  </Card>
  </Collapse>
)}


 {/* --- Consultation Section --- */}
    
{selectedPatient ? (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, minHeight: '70vh' }}>
    {/* Sidebar Tabs */}
    <Paper
      sx={{
        width: { xs: '100%', sm: 64, md: 64 },
        flexShrink: 0,
        borderRadius: { xs: 0, sm: 1 },
        mr: { sm: 2 },
        mb: { xs: 2, sm: 0 },
        maxHeight: { sm: '70vh' },
        overflow: 'auto',
        transition: 'width 0.3s ease',
        '&:hover': {
          width: { sm: 200, md: 240 },
          // Show all tab labels when hovering over the Paper container
          '& .MuiTab-root': {
            fontSize: { sm: '0.875rem' },
            justifyContent: { sm: 'flex-start' },
            paddingLeft: { sm: '16px' },
            '& .MuiTab-iconWrapper': {
              marginRight: { sm: '12px' }
            }
          }
        }
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(e, v) => {
          if (!ensureServiceAndAttendanceSelected()) return;
          setActiveTab(v);
        }}
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          '& .MuiTab-root': {
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: { xs: '100%', sm: 64, md: 64 },
            minHeight: { xs: 52, sm: 64, md: 64 },
            fontSize: { xs: '0.75rem', sm: '0' },
            padding: { xs: '10px 12px', sm: '12px 8px' },
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            '& .MuiTab-iconWrapper': {
              marginBottom: { xs: 0, sm: 0 },
              marginRight: { xs: '8px', sm: 0 }
            },
            '&.Mui-selected': {
              backgroundColor: 'action.selected',
              fontWeight: 600,
            }
          },
        }}
      >
        <Tab
          label="Consultation"
          icon={<LocalHospital />}
          iconPosition="start"
        />
        <Tab
          label="Laboratory"
          icon={<Science />}
          iconPosition="start"
        />
        <Tab
          label="Scan"
          icon={<CameraAlt />}
          iconPosition="start"
        />
        <Tab
          label="Medication"
          icon={<Medication />}
          iconPosition="start"
        />
        <Tab
          label="Other Service"
          icon={<RoomService />}
          iconPosition="start"
        />
        <Tab
          label="Appointment"
          icon={<CalendarMonth />}
          iconPosition="start"
        />
        <Tab
          label="Admit Patient"
          icon={<Hotel />}
          iconPosition="start"
        />
        <Tab
          label="Referee"
          icon={<PersonAdd />}
          iconPosition="start"
        />
      </Tabs>
    </Paper>

    {/* Main Content Area */}
    <Paper sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
      {/* --- Quick Access Buttons --- */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1.5,
          mb: 2,
          justifyContent: "flex-start",
        }}
      >
        <Tooltip title="View full medical record history">
          <Button
          variant="outlined"
          color="primary"
          onClick={() => setMedHistoryOpen(true)}
          startIcon={<Notes />}
        >
          Medical History
        </Button>
        </Tooltip>

         <Tooltip title="Review past Vitals results">
          <Button
            variant="outlined"
            color="success"
           
            startIcon={<History />}
             onClick={() => setVitalsHistoryOpen(true)}
          >
            Vitals History
          </Button>
        </Tooltip>

        <Tooltip title="Review past laboratory results">
          <Button
            variant="outlined"
            color="secondary"
           
            startIcon={<Science />}
             onClick={() => setlabHistoryOpen(true)}
          >
            Lab History
          </Button>
        </Tooltip>

        <Tooltip title="View previous scan/imaging results">
          <Button
            variant="outlined"
            color="info"
             onClick={() => setScanHistoryOpen(true)}
            startIcon={<CameraAlt />}
          >
            Scan History
          </Button>
        </Tooltip>

        <Tooltip title="Check previous medications prescribed">
          <Button
            variant="outlined"
            color="success"
            onClick={() => setopenmedHis(true)}
            startIcon={<Medication />}
          >
            Medication History
          </Button>
        </Tooltip>

        {/* Hidden unless the diagnostic link is configured on the server */}
        <DiagnosticReferralButton
          patient={{ id: selectedPatient.id, name: selectedPatient.fullName }}
          currentUser={currentUser}
          visitDate={selectedPatient.visitDate}
          defaultDiagnosis={(selectedDiagnoses || []).map(d => d.name).filter(Boolean).join(', ')}
        />

      </Box>

      <Divider sx={{ my: 3}} />
   
{/* Tab Content Goes Here - Add your activeTab === 0, 1, 2, etc. */}
{activeTab === 0 && (
  <Box>
    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

{/* Service Provided */}
 <Grid item xs={12} md={6} size={6}>
 <FormControl fullWidth>
  <InputLabel>Select Service Provided</InputLabel>
  <Select
    value={serviceProvided}
    label="Select Service Provided"
    onChange={(e) => {
      const newService = e.target.value;
      setServiceProvided(newService);

      // ✅ Pass both current values explicitly
      if (attendanceType && newService) {
        saveServiceProvided(false, attendanceType, newService);
      }
    }}
  >
    <MenuItem value="">Select Service Provided</MenuItem>
    {insuredServices.length > 0 ? (
      insuredServices.map((srv) => (
        <MenuItem key={srv.id} value={srv.name}>
          {srv.name}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No services found for this insurance</MenuItem>
    )}
  </Select>
</FormControl>


</Grid>


{/* Type of Attendance */}
<Grid item xs={12} md={6} size={6}>
       
<FormControl fullWidth>
  <InputLabel>Type of Attendance</InputLabel>
  <Select
    value={attendanceType}
    label="Type of Attendance"
    onChange={(e) => {
      const newType = e.target.value;
      setAttendanceType(newType);

      // ✅ Pass both new values explicitly
      if (serviceProvided && newType) {
        saveServiceProvided(false, newType, serviceProvided);
      }
    }}
  >
    <MenuItem value="">Select Type Of Attendance</MenuItem>
    <MenuItem value="Chronic Follow-up">Chronic Follow-up</MenuItem>
    <MenuItem value="Emergency/Acute Episode">Emergency/Acute Episode</MenuItem>
    {/*  Not offered to a male patient — the same rule the service list now
         applies on the server. Shown when no sex is recorded, so a blank field
         never hides an option. */}
    {!isMalePatient && <MenuItem value="Antenatal">Antenatal</MenuItem>}
    {!isMalePatient && <MenuItem value="Postnatal">Postnatal</MenuItem>}
  </Select>
</FormControl>


</Grid>

{/*  ── DRAFT THE NOTE FROM THE DOCTOR'S OWN DIAGNOSIS ───────────────────────
     The clinician makes the call — diagnosis, service, attendance — and the AI
     writes it up in short consulting-room style. Anything already typed in the
     boxes is refined, not replaced. Refused without a diagnosis, here and again
     on the server, because without one there is nothing to write up. */}
<Grid item xs={12} size={12}>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
    <Tooltip title={selectedDiagnoses && selectedDiagnoses.length
      ? 'Write complaint, history and examination from your diagnosis — check and edit before saving'
      : 'Select a diagnosis first'}>
      <span>
        <Button
          size="small"
          variant="outlined"
          startIcon={aiDraftingNote ? <CircularProgress size={14} /> : <AutoAwesome />}
          disabled={aiDraftingNote || !selectedDiagnoses || selectedDiagnoses.length === 0}
          onClick={handleAIDraftNote}
          sx={{ textTransform: 'none', fontWeight: 700, borderColor: '#1A9B7F', color: '#1A9B7F' }}
        >
          {aiDraftingNote ? 'Drafting…' : 'Draft note from diagnosis'}
        </Button>
      </span>
    </Tooltip>
    <Typography variant="caption" color="text.secondary">
      AI draft — read it and correct it before you save.
    </Typography>
  </Box>
</Grid>

{/* Complaint */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.complaint}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        handleSuggest("complaint", newInputValue);
        setComplaint(newInputValue);
        setHasEdited(true);
      }
    }}
    
    onChange={(event, newValue, reason) => {
      if (newValue && reason === "selectOption") {
        setComplaint((prev) => {
          const parts = prev.split(/[.,]/);
          parts[parts.length - 1] = ` ${newValue}`;
          return parts.join(", ");
        });
        setHasEdited(true);
      }
    }}

    inputValue={complaint}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Complaint"
        multiline
        rows={6}
        placeholder="Enter patient complaint(s)... separate by , or ."
        name="complaint"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* History */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.history}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setHistory(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}
   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setHistory((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}
    inputValue={history}
    renderInput={(params) => (
      <TextField
        {...params}
        label="History"
        multiline
        rows={6}
        placeholder="Enter patient history... separate by , or ."
        name="history"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
        
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* Physical Examination */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.exam}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setExam(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}

   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setExam((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}

    inputValue={exam}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Physical Examination"
        multiline
        rows={6}
        placeholder="Enter findings... separate by , or ."
        name="exam"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
          
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>

{/* Other Documentation */}
<Grid item xs={12} md={6} size={3}>
  <Autocomplete
    freeSolo
    disableClearable
    options={suggestionsData.other}
    filterOptions={(options, { inputValue }) => {
      const parts = inputValue.split(/[.,]/);
      const last = parts[parts.length - 1].trim().toLowerCase();
      return options.filter((opt) => opt.toLowerCase().includes(last));
    }}
    onInputChange={(event, newInputValue, reason) => {
      if (reason === "input") {
        setOther(newInputValue);
        setHasEdited(true); // ✅ added
      }
    }}
   onChange={(event, newValue, reason) => {
  if (newValue && reason === "selectOption") {
    setOther((prev) => {
      const parts = prev.split(/[.,]/);
      parts[parts.length - 1] = ` ${newValue}`;
      return parts.join(", ");
    });
    setHasEdited(true);
  }
}}
    inputValue={other}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Other Documentation"
        multiline
        rows={6}
        placeholder="Enter additional notes... separate by , or ."
        name="other"
        autoComplete="on"
        inputProps={{
          ...params.inputProps,
         
          spellCheck: true,
          autoCapitalize: "sentences",
        }}
      />
    )}
  />
 
</Grid>


{/* Diagnosis(es) */}
<Grid item xs={12} md={6} size={12} >
  <Typography variant="subtitle1" gutterBottom>
    Diagnosis(es)
  </Typography>

  <Autocomplete
    multiple
    options={diagnosisOptions}
    value={selectedDiagnoses || []}
    onChange={(event, newValue) => {
      setSelectedDiagnoses(newValue);
      saveOrUpdateDiagnosis(newValue); // ✅ CALL FUNCTION HERE
    }}
    getOptionLabel={(option) =>
      option && option.code && option.name
        ? `${option.name}`
        : ""
    }
    filterSelectedOptions
    isOptionEqualToValue={(option, value) => option.id === value.id}
    filterOptions={(options, { inputValue }) => {
      const search = inputValue.toLowerCase();
      return options.filter(
        (opt) =>
          opt.name.toLowerCase().includes(search) ||
          opt.code.toLowerCase().includes(search) ||
          (opt.cat && opt.cat.toLowerCase().includes(search)) ||
          (opt.core && opt.core.toString().toLowerCase().includes(search))
      );
    }}
    renderInput={(params) => (
      <TextField {...params} placeholder="Search by code or diagnosis name..." />
    )}
    renderOption={(props, option) => (
      <li {...props} key={option.id}>
        <Box>
          <Typography variant="body2" color="bold">
            {option.name}
          </Typography>
        </Box>
      </li>
    )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          key={option.id}
          label= {option.name}
          {...getTagProps({ index })}
          size="small"
        />
      ))
    }
  />
</Grid>


{/* Procedure(s) */}
<Grid item xs={12} md={6} size={12}>
  <Typography variant="subtitle1" gutterBottom>
    Procedure(s)
  </Typography>

  <Autocomplete
    multiple
    options={procedureOptions}
    value={selectedProcedures || []}
    onChange={(event, newValue) => {
      setSelectedProcedures(newValue);
      saveOrUpdateProcedure(newValue); // ✅ SAVE ON CHANGE
    }}
    getOptionLabel={(option) =>
      option && option.name ? `${option.name}` : ""
    }
    filterSelectedOptions
    isOptionEqualToValue={(option, value) => option.id === value.id}
    filterOptions={(options, { inputValue }) => {
      const search = inputValue.toLowerCase();
      return options.filter((opt) =>
        opt.name && opt.name.toLowerCase().includes(search)
      );
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder="Search by procedure code or name..."
      />
    )}
    renderOption={(props, option) => (
      <li {...props} key={option.id}>
        <Box>
          <Typography variant="body2" color="bold">
            {option.name}
          </Typography>
        </Box>
      </li>
    )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          key={option.id}
          label={option.name}
          {...getTagProps({ index })}
          size="small"
        />
      ))
    }
  />
</Grid>


</Grid>
    
  </Box>
)}

{/* --- Laboratory --- */}
{activeTab === 1 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Labs (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Labs
        </Typography>
        <TextField
          fullWidth
          placeholder="Search lab by name..."
          value={labSearchTerm}
          onChange={(e) => setLabSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        {/* Responsive Table */}
        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {labs
                .filter((lab) =>
                  lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
                )
                .slice(labPage * labRowsPerPage, labPage * labRowsPerPage + labRowsPerPage)
                .map((lab, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{lab.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}> {formatWithOutSom (lab.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestLab(lab)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={labs.filter((lab) =>
            lab.name.toLowerCase().includes(labSearchTerm.toLowerCase())
          ).length}
          page={labPage}
          onPageChange={(e, newPage) => setLabPage(newPage)}
          rowsPerPage={labRowsPerPage}
          onRowsPerPageChange={(e) => {
            setLabRowsPerPage(parseInt(e.target.value, 10));
            setLabPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Labs (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Labs
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Lab</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedLabs
                .slice(reqPage * reqRowsPerPage, reqPage * reqRowsPerPage + reqRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.labBy || "-"}</TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        size="small"
                       
                        onClick={() => handleDeleteRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedLabs.length}
          page={reqPage}
          onPageChange={(e, newPage) => setReqPage(newPage)}
          rowsPerPage={reqRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqRowsPerPage(parseInt(e.target.value, 10));
            setReqPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals Section */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e3f2fd, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedLabs
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* --- Scan --- */}
{activeTab === 2 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Scans (Left Side) --- */}
    <Grid item xs={12} md={6} size={5}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Scans
        </Typography>
        <TextField
          fullWidth
          placeholder="Search scan by name..."
          value={scanSearchTerm}
          onChange={(e) => setScanSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="small"
        />

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                  Request
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {scans
                .filter((scan) =>
                  scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
                )
                .slice(scanPage * scanRowsPerPage, scanPage * scanRowsPerPage + scanRowsPerPage)
                .map((scan, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{scan.name}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(scan.amount)}</TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleRequestScan(scan)} size="small">
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={scans.filter((scan) =>
            scan.name.toLowerCase().includes(scanSearchTerm.toLowerCase())
          ).length}
          page={scanPage}
          onPageChange={(e, newPage) => setScanPage(newPage)}
          rowsPerPage={scanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setScanRowsPerPage(parseInt(e.target.value, 10));
            setScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Requested Scans (Right Side) --- */}
    <Grid item xs={12} md={6} size={7}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Scans
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Scan By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedScans
                .slice(reqScanPage * reqScanRowsPerPage, reqScanPage * reqScanRowsPerPage + reqScanRowsPerPage)
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.lab}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.scanBy || "-"}</TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        size="small"
                        
                        onClick={() => handleDeleteScanRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedScans.length}
          page={reqScanPage}
          onPageChange={(e, newPage) => setReqScanPage(newPage)}
          rowsPerPage={reqScanRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqScanRowsPerPage(parseInt(e.target.value, 10));
            setReqScanPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #fff3e0, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom (requestedScans
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + r.amount, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* --- Medication --- */}
{activeTab === 3 && (
  <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
    
    {/* --- Full View Button --- */}
   
     <Button
      fullWidth
      variant="outlined"
      color="primary"
      size="large"
      onClick={() => setMedDialogOpen(true)}
      sx={{
        py: 2,            // taller button
        fontSize: "1rem", // bigger text
        fontWeight: 600
      }}
    >
      Open Full Medication View
    </Button>
   

    {/* --- Available Medications (Column 1) --- */}
    <Grid item xs={12} md={4} size={3}>
     
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Available Medications
        </Typography>

        <TextField
          fullWidth
          placeholder="Search medication..."
          value={medSearchTerm}
          onChange={(e) => setMedSearchTerm(e.target.value)}
          size="big"
          margin="dense"
        />

        <AgeBandNotice meta={medAgeMeta} showAll={showAllAges} onToggle={toggleAllAges} />

        <TableContainer sx={{ maxHeight: 450 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Medication</TableCell>
                <TableCell align="center" sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                  Select
                </TableCell>
              </TableRow>
            </TableHead>
            {/* In activeTab === 3 - Available Medications */}
            <TableBody>
              {medications
                .filter((med) => med.name.toLowerCase().includes(medSearchTerm.toLowerCase()))
                .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                .map((med, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ 
                      "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                      // ✅ Highlight chronic medications
                      backgroundColor: isMedicationChronic(med.name) ? '#e8f5e9' : 'inherit',
                      borderLeft: isMedicationChronic(med.name) ? '4px solid #4caf50' : 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: isMedicationChronic(med.name) ? '#c8e6c9' : 'action.hover',
                      }
                    }}
                  >
                    <TableCell sx={{ fontSize: "0.8rem" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {med.name}
                      <AgeBandChip value={med.age_cat} />
                      {isMedicationChronic(med.name) && (
                        <Chip 
                          label="Chronic drug" 
                          size="small" 
                          color="success" 
                          sx={{ 
                            height: 20, 
                            fontSize: '0.65rem',
                            fontWeight: 600
                          }} 
                        />
                      )}
                      <Tooltip title="Medication Info">
                        <IconButton
                          size="small"
                          color="info"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMedicationInfo(med);
                          }}
                          sx={{ ml: 'auto' }}
                        >
                          <Info fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>

                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleSelectMedication(med)}
                      >
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={medications.filter((med) =>
            med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
          ).length}
          page={medPage}
          onPageChange={(e, newPage) => setMedPage(newPage)}
          rowsPerPage={medRowsPerPage}
          onRowsPerPageChange={(e) => {
            setMedRowsPerPage(parseInt(e.target.value, 10));
            setMedPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Grid>

    {/* --- Medication Request Form (Column 2) --- */}
    <Grid item xs={12} md={4} size={3}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Medication Request
        </Typography>

       <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />


        <FormControlLabel
          control={
            <Checkbox
              checked={autoCalculate}
              onChange={(e) => setAutoCalculate(e.target.checked)}
              size="big"
            />
          }
          label={<Typography fontSize="0.8rem">Auto Calculate Quantity</Typography>}
          sx={{ mb: 1 }}
        />

        
          
            <TextField
              label="Amount per dose" placeholder="Amount taken at one time"
              type="text"
              value={doseAmount}
              onChange={(e) => {
                setDoseAmount(e.target.value);
                if (e.target.value) setDoseAmountError(false);
              }}
              fullWidth
              size="big"
              margin="dense"
              error={doseAmountError}
              helperText={doseAmountError ? "Required" : ""}
            />
          
          
            <TextField
              label="Dose Unit"
              placeholder="ml, mg, tab"
              value={doseUnit}
              onChange={(e) => setDoseUnit(e.target.value)}
              fullWidth
              size="big"
              margin="dense"
            />
          
      
        <FormControl fullWidth margin="dense" size="big" error={frequencyError}>
          <InputLabel>Frequency</InputLabel>
          <Select
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              if (e.target.value) setFrequencyError(false);
            }}
          >
            {standardFrequencies.map((freq) => (
              <MenuItem key={freq} value={freq} sx={{ fontSize: "0.85rem" }}>
                {freq}
              </MenuItem>
            ))}
          </Select>
          {frequencyError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

        <TextField
          label="Days"
          type="number"
          value={days}
          onChange={(e) => {
            const val = Number(e.target.value);
            setDays(val);
            if (val > 0) setDaysError(false);
          }}
          fullWidth
          size="big"
          margin="dense"
          error={daysError}
          helperText={daysError ? "Must be > 0" : ""}
        />

        <FormControl fullWidth margin="dense" size="big" error={routeError}>
          <InputLabel>Route</InputLabel>
          <Select
            value={route}
            onChange={(e) => {
              setRoute(e.target.value);
              if (e.target.value) setRouteError(false);
            }}
          >
            {MEDICATION_ROUTES.map((rt) => (
              <MenuItem key={rt} value={rt} sx={{ fontSize: "0.85rem" }}>
                {rt}
              </MenuItem>
            ))}
          </Select>
          {routeError && <FormHelperText>Required</FormHelperText>}
        </FormControl>

         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />

        <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
          <Button 
            fullWidth 
            variant="contained" 
            size="small" 
            onClick={handleAddMedication}
          >
            Make Request
          </Button>
          <Button 
            fullWidth 
            variant="outlined" 
            color="error" 
            size="small"
            onClick={handleClearMedication}
          >
            Clear
          </Button>
        </Stack>
      </Paper>
    </Grid>

    {/* --- Requested Medications (Column 3) --- */}
    <Grid item xs={12} md={4} size={6}>
      <Paper sx={{ p: 1.5, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          Requested Medications
        </Typography>

        <TableContainer sx={{ maxHeight: 350 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {["Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost"].map((col) => (
                  <TableCell
                    key={col}
                    sx={{ fontSize: "0.8rem", fontWeight: "bold", py: 0.5 }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedMeds
                .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                .map((req, idx) => (
                  <TableRow key={idx} sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.drug}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.dose}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.freq}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.days}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.qty}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>{req.route}</TableCell>
                    <TableCell sx={{ fontSize: "0.8rem", py: 0.5 }}>GH₵ {req.cost}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedMeds.length}
          page={reqMedPage}
          onPageChange={(e, newPage) => setReqMedPage(newPage)}
          rowsPerPage={reqMedRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqMedRowsPerPage(parseInt(e.target.value, 10));
            setReqMedPage(0);
          }}
          rowsPerPageOptions={[10, 20, 35]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/* Other Serivces --*/}
{activeTab === 4 && (
  <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
    {/* --- Available Services (Left) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Available Non Insured Services
        </Typography>

        <TextField
          fullWidth
          placeholder="Search  Non Insured Services by name..."
          value={serviceSearchTerm}
          onChange={(e) => setServiceSearchTerm(e.target.value)}
          sx={{ mb: 2 }}
          size="big"
        />
        

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
           <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Quantity</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
              <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }} align="center">
                Request
              </TableCell>
            </TableRow>
          </TableHead>

           <TableBody>
  {services
    .filter((srv) =>
      srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
    )
    .slice(servicePage * serviceRowsPerPage, servicePage * serviceRowsPerPage + serviceRowsPerPage)
    .map((srv, idx) => {
      const key = `${srv.name}-${idx}`;
      const quantity = serviceQuantities[key] || 1;
      const finalAmount = srv.amount * quantity;

      return (
        <TableRow key={key}>
          {/* Service Name */}
          <TableCell>{srv.name}</TableCell>

          {/* Quantity Input */}
          <TableCell>
            <TextField
              type="number"
              size="small"
              value={quantity}
              inputProps={{ min: 1 }}
              onChange={(e) => {
                const val = Math.max(1, Number(e.target.value));
                setServiceQuantities((prev) => ({ ...prev, [key]: val }));
              }}
              sx={{ width: 80 }}
            />
          </TableCell>

          {/* Auto-updated Amount */}
          <TableCell>{formatWithOutSom(finalAmount)}</TableCell>

          {/* Request Button */}
          <TableCell align="center">
            <IconButton
              color="primary"
              onClick={() =>
                handleRequestService({
                  ...srv,
                  amount: finalAmount,     // 👈 send multiplied amount
                  quantity,
                })
              }
            >
              <Send />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    })}
</TableBody>

          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={services.filter((srv) =>
            srv.name.toLowerCase().includes(serviceSearchTerm.toLowerCase())
          ).length}
          page={servicePage}
          onPageChange={(e, newPage) => setServicePage(newPage)}
          rowsPerPage={serviceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setServiceRowsPerPage(parseInt(e.target.value, 10));
            setServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>

      <Paper
      elevation={2}
      sx={{
        mt: 2,
        p: 2,
        borderRadius: 3,
        background: "linear-gradient(135deg,#fdfbfb 0%,#ebedee 100%)"
      }}
    >
      <Typography fontWeight={600} mb={2}>
        Request Service Not Listed
      </Typography>

      <Grid container spacing={2} alignItems="center" columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={12} md={5} size={6}>
          <TextField
            fullWidth
            size="small"
            label="Service Name"
            value={manualServiceName}
            onChange={(e) => setManualServiceName(e.target.value)}
          />
        </Grid>


        <Grid item xs={12} md={3} size={3}>
          <TextField
            fullWidth
            size="small"
            type="number"
            label="Amount"
            value={manualAmount}
            onChange={(e) => setManualAmount(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={2} size={3}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<Send />}
            onClick={handleManualServiceRequest}
            sx={{
              height: 40,
              background:
                "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
              borderRadius: 2
            }}
          >
            Request
          </Button>
        </Grid>
      </Grid>
    </Paper>

    </Grid>

    {/* --- Requested Services (Right) --- */}
    <Grid item xs={12} md={6} size={6}>
      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Requested Services
        </Typography>

        <TableContainer sx={{ maxHeight: 400, overflowX: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Service</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Requested By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Paid By</TableCell>
                <TableCell sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestedServices
                .slice(
                  reqServicePage * reqServiceRowsPerPage,
                  reqServicePage * reqServiceRowsPerPage + reqServiceRowsPerPage
                )
                .map((req, idx) => (
                  <TableRow
                    key={idx}
                    sx={{ "&:nth-of-type(odd)": { backgroundColor: "action.hover" } }}
                  >
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.date}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.service}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{ formatWithOutSom(req.amount)}</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.requestedBy}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={req.status}
                        color={req.status === "paid" ? "success" : "warning"}
                        sx={{ fontSize: "0.7rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ fontSize: "0.75rem" }}>{req.servicedBy || "-"}</TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        size="small"
                       
                        onClick={() => handleDeleteServiceRequest(req)}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={requestedServices.length}
          page={reqServicePage}
          onPageChange={(e, newPage) => setReqServicePage(newPage)}
          rowsPerPage={reqServiceRowsPerPage}
          onRowsPerPageChange={(e) => {
            setReqServiceRowsPerPage(parseInt(e.target.value, 10));
            setReqServicePage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />

        {/* Totals */}
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #e1f5fe, #f1f8e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Total Pending: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "pending")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

          <Typography variant="caption" fontWeight="bold" color="success.main">
            Total Paid: GH₵{" "}
            {formatWithOutSom(requestedServices
              .filter((r) => r.status === "paid")
              .reduce((sum, r) => sum + Number(r.amount), 0))}
          </Typography>

        </Box>
      </Paper>
    </Grid>
  </Grid>
)}

{/*-- Approintment --*/}

{activeTab === 5 && (
  <Box>
    <Grid container spacing={3}>

      {/* ---------- APPOINTMENT FORM ONLY ---------- */}
      <Grid item xs={12} >
        <Paper sx={{ p: 3 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, mb: 3 }}
            color="primary"
          >
            {editingAppointmentId ? "Update Appointment" : "Book New Appointment"}
          </Typography>

          <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Appointment Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={appointmentDate}
                onChange={(e) => setAppointmentDate(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} size={6}>
              <TextField
                fullWidth
                label="Time"
                type="time"
                InputLabelProps={{ shrink: true }}
                value={appointmentTime}
                onChange={(e) => setAppointmentTime(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Type of Appointment</InputLabel>
                <Select
                  value={appointmentType}
                  onChange={(e) => setAppointmentType(e.target.value)}
                  label="Type of Appointment"
                >
                  <MenuItem value="Consultation">Consultation</MenuItem>
                  <MenuItem value="Review">Review</MenuItem>
                  <MenuItem value="Procedure">Procedure</MenuItem>
                  <MenuItem value="Telemedicine">Telemedicine</MenuItem>
                  <MenuItem value="Follow-up">Follow-up</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} size={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendReminder}
                    onChange={(e) => setSendReminder(e.target.checked)}
                  />
                }
                label="Send Reminder"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Reason for Appointment"
                multiline
                rows={3}
                value={appointmentReason}
                onChange={(e) => setAppointmentReason(e.target.value)}
                size="small"
              />
            </Grid>

            <Grid item xs={12} size={6}>
              <TextField
                fullWidth
                label="Other Information"
                multiline
                rows={3}
                value={appointmentOther}
                onChange={(e) => setAppointmentOther(e.target.value)}
                size="small"
              />
            </Grid>

            {/* SAVE or UPDATE BUTTON */}
            <Grid item xs={12} size={6}>
              <Button
                variant="contained"
                color={editingAppointmentId ? "warning" : "primary"}
                startIcon={<SaveIcon />}
                onClick={handleSaveAppointment}
              >
                {editingAppointmentId ? "Update Appointment" : "Save Appointment"}
              </Button>
            </Grid>

            {/* DELETE BUTTON — Only visible in edit mode */}
            {editingAppointmentId && (
              <Grid item xs={12} size={6}>
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<Delete />}
                  onClick={() => handleDeleteAppointment(editingAppointmentId)}
                  sx={{ ml: 2 }}
                >
                  Delete Appointment
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  </Box>
)}


{activeTab === 6 && (
  <Box>
    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
      Admit Patient
    </Typography>

    <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* ---------- Row 1: Complaint, History, Physical Exam, Other Document ---------- */}
      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Complaint"
          multiline
          rows={4}
          value={complaint}
          disabled
          onChange={(e) => setComplaint(e.target.value)}
          placeholder="Enter patient's complaint..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="History"
          multiline
          rows={4}
          value={history}
          disabled
          onChange={(e) => setHistory(e.target.value)}
          placeholder="Enter relevant patient history..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Physical Exam"
          multiline
          rows={4}
          value={exam}
          disabled
          onChange={(e) => setExam(e.target.value)}
          placeholder="Enter physical exam findings..."
        />
      </Grid>

      <Grid item xs={12} md={3} size={3}>
        <TextField
          fullWidth
          label="Other Document"
          multiline
          rows={4}
          value={other}
          disabled
          onChange={(e) => setOther(e.target.value)}
          placeholder="Enter other relevant notes or documents..."
        />
      </Grid>

      {/* ---------- Row 2: Diagnoses and Procedures ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Diagnoses
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedDiagnoses && selectedDiagnoses.length > 0 ? (
            selectedDiagnoses.map((diag, idx) => (
              <Chip key={idx} label={diag.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No diagnosis selected
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Procedures
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {selectedProcedures && selectedProcedures.length > 0 ? (
            selectedProcedures.map((proc, idx) => (
              <Chip key={idx} label={proc.name} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No procedure selected
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 3: Laboratory & Scan Requested ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Laboratory Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedLabs.length > 0 ? (
            requestedLabs.map((lab, idx) => (
              <Chip key={idx} label={lab.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No lab requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Scan Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedScans.length > 0 ? (
            requestedScans.map((scan, idx) => (
              <Chip key={idx} label={scan.lab} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No scan requested
            </Typography>
          )}
        </Box>
      </Grid>

      {/* ---------- Row 4: Medications & Other Services ---------- */}
      <Grid item xs={12} md={6} size={9}>
        <Typography variant="subtitle1" fontWeight={600}>
          Medications Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedMeds.length > 0 ? (
            requestedMeds.map((med, idx) => (
              <Chip key={idx} label={med.drug} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No medication requested
            </Typography>
          )}
        </Box>
      </Grid>

      <Grid item xs={12} md={6} size={3}>
        <Typography variant="subtitle1" fontWeight={600}>
          Other Services Requested
        </Typography>
        <Box sx={{ border: "1px solid #ccc", borderRadius: 1, p: 2, minHeight: 80 }}>
          {requestedServices.length > 0 ? (
            requestedServices.map((srv, idx) => (
              <Chip key={idx} label={srv.service} sx={{ m: 0.5 }} />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No service requested
            </Typography>
          )}
        </Box>
      </Grid>


      {/* ---------- Row 4.5: Admission Status ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <FormControl fullWidth>
          <InputLabel id="admission-status-label">Admission Status</InputLabel>
          <Select
            labelId="admission-status-label"
            label="Admission Status"
            value={admissionStatus}
            onChange={(e) => setAdmissionStatus(e.target.value)}
          >
            <MenuItem value="Admission">Admission</MenuItem>
            <MenuItem value="Detention">Detention</MenuItem>
             <MenuItem value="Emergency">Emergency</MenuItem>
          </Select>
        </FormControl>
      </Grid>


      {/* ---------- Row 5: Date & Time of Admission ---------- */}
      <Grid item xs={12} md={6} size={2}>
        <TextField
          fullWidth
          label="Date of Admission"
          type="date"
          value={admissionDate}
          disabled
          onChange={(e) => setAdmissionDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} md={6}size={2}>
        <TextField
          fullWidth
          label="Time of Admission"
          type="time"
          value={admissionTime}
          onChange={(e) => setAdmissionTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* ---------- Row 6: Admission Note & Treatment Plan ---------- */}
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Reason for Admission"
          multiline
          rows={5}
          value={admissionNote}
          onChange={(e) => setAdmissionNote(e.target.value)}
          placeholder="Enter detailed admission Reason /  note..."
        />
      </Grid>
      
      <Grid item xs={12} md={6} size={3}>
        <TextField
          fullWidth
          label="Treatment Plan"
          multiline
          rows={5}
          value={treatmentPlan}
          onChange={(e) => setTreatmentPlan(e.target.value)}
          placeholder="Enter treatment plan..."
        />
      </Grid>
    </Grid>

    {/* Submit / Admit Button */}
    <Box sx={{ textAlign: "right", mt: 3 }}>
  <Button
    variant="contained"
    color="primary"
    startIcon={<Hotel />}
    onClick={() => {
      if (!validateAdmissionForm()) return;

      // 👉 Submit to backend
      submitAdmission();
      }}
  >
    Admit Patient
  </Button>

    </Box>
  </Box>
)}    

</Paper>
  </Box>
) : (
  <Paper
    sx={{
      p: 6,
      textAlign: "center",
      height: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box>
      <Person sx={{ fontSize: 80, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        Search and select a patient to begin consultation
      </Typography>
    </Box>
  </Paper>
)}



<Dialog open={medDialogOpen} onClose={() => setMedDialogOpen(false)} maxWidth="lx" fullWidth>
  <DialogTitle>Medication Full View</DialogTitle>
  <DialogContent>
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>

      {/* --- Available Medications (Column 1) --- */}
      <Grid item xs={12} md={4} size={3}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Available Medications
          </Typography>

          <TextField
            fullWidth
            placeholder="Search medication..."
            value={medSearchTerm}
            onChange={(e) => setMedSearchTerm(e.target.value)}
            size="big"
            margin="dense"
            sx={{ mb: 1 }}
          />

          <AgeBandNotice meta={medAgeMeta} showAll={showAllAges} onToggle={toggleAllAges} />

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Medication</TableCell>
                  <TableCell align="center">Select</TableCell>
                </TableRow>
              </TableHead>
              {/* In the Dialog - Available Medications */}
            <TableBody>
              {medications
                .filter((med) =>
                  med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
                )
                .slice(medPage * medRowsPerPage, medPage * medRowsPerPage + medRowsPerPage)
                .map((med, idx) => (
                  <TableRow 
                    key={idx}
                    sx={{ 
                      "&:nth-of-type(odd)": { backgroundColor: "action.hover" },
                      // ✅ Highlight chronic medications
                      backgroundColor: isMedicationChronic(med.name) ? '#e8f5e9' : 'inherit',
                      borderLeft: isMedicationChronic(med.name) ? '4px solid #4caf50' : 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: isMedicationChronic(med.name) ? '#c8e6c9' : 'action.hover',
                      }
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {med.name}
                        <AgeBandChip value={med.age_cat} />
                        {isMedicationChronic(med.name) && (
                          <Chip 
                            label="Chronic drug" 
                            size="small" 
                            color="success" 
                            sx={{ 
                              height: 20, 
                              fontSize: '0.65rem',
                              fontWeight: 600
                            }} 
                          />
                        )}
                        <Tooltip title="Medication Info">
                          <IconButton
                            size="small"
                            color="info"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMedicationInfo(med);
                            }}
                            sx={{ ml: 'auto' }}
                          >
                            <Info fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                    
                    <TableCell align="center">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleSelectMedication(med)}
                      >
                        <Send fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={medications.filter((med) =>
              med.name.toLowerCase().includes(medSearchTerm.toLowerCase())
            ).length}
            page={medPage}
            onPageChange={(e, newPage) => setMedPage(newPage)}
            rowsPerPage={medRowsPerPage}
            onRowsPerPageChange={(e) => {
              setMedRowsPerPage(parseInt(e.target.value, 10));
              setMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
        </Paper>
      </Grid>

      {/* --- Medication Request (Column 2) --- */}
      <Grid item xs={12} md={4} size={2} >
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Medication Request
          </Typography>

          {/* Selected Medication */}
           <TextField
          label="Selected Medication"
          value={selectedMed?.name || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // text color
              opacity: 1,                    // remove dim
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                 // label color
              opacity: 1,
            }
          }}
        />

        <TextField
          label="Medication Status"
          value={selectedMed?.status || ""}
          fullWidth
          margin="dense"
          disabled
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",
              opacity: 1,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",
              opacity: 1,
            }
          }}
        />

          {/* Auto Calculate Toggle */}
          <FormControlLabel
            control={
              <Checkbox
                checked={autoCalculate}
                onChange={(e) => setAutoCalculate(e.target.checked)}
                size="big"
              />
            }
            label="Auto Calculate Quantity"
            sx={{ mb: 1 }}
          />

              <TextField
                label="Amount per dose" placeholder="Amount taken at one time"
                type="text"
                value={doseAmount}
                onChange={(e) => setDoseAmount(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />
           
            
              <TextField
                label="Dose Unit"
                value={doseUnit}
                onChange={(e) => setDoseUnit(e.target.value)}
                fullWidth
                size="big"
                margin="dense"
              />

          {/* Frequency */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Frequency</InputLabel>
            <Select
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
            >
              {standardFrequencies.map((freq) => (
                <MenuItem key={freq} value={freq}>{freq}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Days */}
          <TextField
            label="Days"
            type="number"
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
            fullWidth
            size="big"
            margin="dense"
          />

          {/* Route */}
          <FormControl fullWidth margin="dense" size="big">
            <InputLabel>Route</InputLabel>
            <Select value={route} onChange={(e) => setRoute(e.target.value)}>
              {MEDICATION_ROUTES.map((rt) => (
                <MenuItem key={rt} value={rt}>{rt}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Quantity */}
         <TextField
          label="Quantity"
          type="number"
          value={qty}
          onChange={(e) => !autoCalculate && setQty(Number(e.target.value))}
          fullWidth
          size="big"
          margin="dense"
          disabled={autoCalculate}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000",   // makes text black
              opacity: 1,                     // full visibility
            },

            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#000",                // label color readable
              opacity: 1,
            },

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            }
          }}
        />


          {/* Buttons (Update or Add) */}
          <Stack spacing={1} direction="row" sx={{ mt: 1 }}>
            {editingIndex !== null ? (
              <Button fullWidth variant="contained" size="small" color="success" onClick={handleUpdateMedication}>
                Update Request
              </Button>
            ) : (
              <Button fullWidth variant="contained" size="small" onClick={handleAddMedication}>
                Make Request
              </Button>
            )}
            <Button
              fullWidth
              variant="outlined"
              color="error"
              size="big"
              onClick={handleClearMedication}
            >
              Clear
            </Button>
          </Stack>
        </Paper>
      </Grid>

      {/* --- Requested Medications (Column 3) --- */}
      <Grid item xs={12} md={4} size={7}>
        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Requested Medications
          </Typography>

          <TableContainer sx={{ maxHeight: 600 }}>
            <Table size="big" stickyHeader>
              <TableHead>
                <TableRow>
                  {["Date", "Drug", "Dose", "Freq", "Days", "Qty", "Route", "Cost", "Requested By", "Served By", "Status", "Action"].map((col) => (
                    <TableCell key={col}>{col}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {requestedMeds
                  .slice(reqMedPage * reqMedRowsPerPage, reqMedPage * reqMedRowsPerPage + reqMedRowsPerPage)
                  .map((req, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{req.date}</TableCell>
                      <TableCell>{req.drug}</TableCell>
                      <TableCell>{req.dose}</TableCell>
                      <TableCell>{req.freq}</TableCell>
                      <TableCell>{req.days}</TableCell>
                      <TableCell>{req.qty}</TableCell>
                      <TableCell>{req.route}</TableCell>
                      <TableCell>{req.cost}</TableCell>
                      <TableCell>{req.requestedBy || "Doctor A"}</TableCell>
                      <TableCell>{req.servedBy || "-"}</TableCell>
                      <TableCell sx={{ color: req.status === "paid" ? "green" : "orange" }}>
                        {req.status} 
                      </TableCell>
                     <TableCell>
                      <>
                        {/* Chronic Refill Icon */}
                        <Tooltip title="Chronic Medication Refill">
                          <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => handleChronicRefill(req)}  // <— create this function
                          >
                            <LocalHospitalIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Edit Medication */}
                        {req.status === "pending" && (
                          <Tooltip title="Edit Medication Request">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleEditMedication(idx)}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Delete Medication */}
                        <Tooltip title="Delete Medication Request">
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteMedication(req)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </>
                    </TableCell>

                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={requestedMeds.length}
            page={reqMedPage}
            onPageChange={(e, newPage) => setReqMedPage(newPage)}
            rowsPerPage={reqMedRowsPerPage}
            onRowsPerPageChange={(e) => {
              setReqMedRowsPerPage(parseInt(e.target.value, 10));
              setReqMedPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
          />
          {/* Totals */}
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #f3e5f5, #e8f5e9)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" fontWeight="bold" color="warning.main">
            Pending: GH₵{" "}
            {formatWithOutSom (requestedMeds.filter((r) => r.status === "pending").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
          <Typography variant="caption" fontWeight="bold" color="success.main">
            Paid: GH₵{" "}
            {formatWithOutSom(requestedMeds.filter((r) => r.status === "paid").reduce((sum, r) => sum + r.cost, 0))}
          </Typography>
        </Box>
        </Paper>
      </Grid>
    </Grid>
  </DialogContent>
</Dialog>


{/* Medication Information Dialog */}
<Dialog 
  open={medInfoDialogOpen} 
  onClose={() => {
    setMedInfoDialogOpen(false);
    setMedInfoLoading(false); // ✅ Reset loading on close
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
    <Box display="flex" alignItems="center" gap={1}>
      <Medication />
      <Typography variant="h6">Medication Information</Typography>
    </Box>
  </DialogTitle>
  
  <DialogContent sx={{ mt: 2, minHeight: 300 }}>
    {selectedMedInfo ? (
      <Box>
        {/* Medication Name */}
        <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
          <Typography variant="h6" fontWeight={600} color="primary">
            {selectedMedInfo.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Code: {selectedMedInfo.code || 'N/A'}
          </Typography>
        </Paper>

        {/* Status & Pricing */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                Status
              </Typography>
              <Typography variant="h6" fontWeight={600}>
                <Chip 
                  label={selectedMedInfo.status} 
                  color={selectedMedInfo.status === 'Non Insured' ? 'warning' : 'success'}
                  sx={{ mt: 1 }}
                />
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={6}>
            <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary">
                Unit Of Pricing
              </Typography>
              <Typography variant="h6" fontWeight={600} color="success.main" sx={{ mt: 1 }}>
                 {selectedMedInfo.pricing}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Stock Information */}
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
          Stock Availability
        </Typography>

        {/* ✅ Show loading or stock info */}
        {medInfoLoading ? (
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'center',
              minHeight: 200,
              gap: 2
            }}
          >
            <CircularProgress size={50} thickness={4} />
            <Typography variant="body2" color="text.secondary">
              Loading stock information...
            </Typography>
          </Box>
        ) : (
          <>
            {/* Dispensary Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2, 
                mb: 2,
                border: '2px solid',
                borderColor: 'primary.main',
                bgcolor: '#e3f2fd'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Dispensary Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Available for immediate dispensing
                  </Typography>
                </Box>
                <Chip
                  label={`${selectedMedInfo.available_qty ?? selectedMedInfo.dispensary_stock ?? 0} available`}
                  color={
                    (selectedMedInfo.dispensary_stock || 0) > 50 
                      ? 'success' 
                      : (selectedMedInfo.dispensary_stock || 0) > 0 
                        ? 'warning' 
                        : 'error'
                  }
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {(selectedMedInfo.reserved ?? 0) > 0 && (
              <Box sx={{ mt: 1, px: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  🔒 {selectedMedInfo.reserved} unit(s) reserved by pending prescriptions
                </Typography>
              </Box>
            )}



            {/* Store Stock */}
            <Paper 
              elevation={2} 
              sx={{ 
                p: 2,
                border: '2px solid',
                borderColor: 'secondary.main',
                bgcolor: '#f3e5f5'
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2" fontWeight={600}>
                    Store Stock
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Main inventory
                  </Typography>
                </Box>
                <Chip
                  label={
                    (selectedMedInfo.store_stock || 0) > 0 
                      ? 'In Stock' 
                      : 'Out of Stock'
                  }
                  color={(selectedMedInfo.store_stock || 0) > 0 ? 'success' : 'error'}
                  sx={{ 
                    fontWeight: 700,
                    fontSize: '1rem',
                    height: 36,
                    minWidth: 100
                  }}
                />
              </Box>
            </Paper>

            {/* Low Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) < 10 && (selectedMedInfo.dispensary_stock || 0) > 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#fff3e0',
                  borderRadius: 1,
                  border: '1px solid #ff9800'
                }}
              >
                <Typography variant="body2" color="warning.dark" fontWeight={600}>
                  ⚠️ Low Stock Alert: Please restock soon
                </Typography>
              </Box>
            )}

            {/* Out of Stock Warning */}
            {(selectedMedInfo.dispensary_stock || 0) === 0 && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#ffebee',
                  borderRadius: 1,
                  border: '1px solid #f44336'
                }}
              >
                <Typography variant="body2" color="error.dark" fontWeight={600}>
                  ❌ Out of Stock: Cannot dispense at this time
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    ) : (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: 300
        }}
      >
        <CircularProgress />
      </Box>
    )}
  </DialogContent>
  
  <DialogActions>
    <Button 
      onClick={() => {
        setMedInfoDialogOpen(false);
        setMedInfoLoading(false); // ✅ Reset loading
        setSelectedMedInfo(null); // ✅ Clear data
      }} 
      variant="contained"
      disabled={medInfoLoading} // ✅ Disable while loading
    >
      Close
    </Button>
  </DialogActions>
</Dialog>


{/* ALL History */}
<MedicalHistoryDialog
  open={medHistoryOpen}
  onClose={() => setMedHistoryOpen(false)}
  patientData={selectedPatient}
/>

{/* lab History */}
<LabHistoryDialog
  open={labHistoryOpen}
  onClose={() => setlabHistoryOpen(false)}
  patientData={selectedPatient}
/>


{/* Scan History */}
<ScanHistoryDialog
  open={ScanHistoryOpen}
  onClose={() => setScanHistoryOpen(false)}
  patientData={selectedPatient}
/>


<VitalsHistoryDialog
  open={vitalsHistoryOpen}
  onClose={() => setVitalsHistoryOpen(false)}
  patientData={selectedPatient}
/>


 {/* Medication History */}
    <MedicationHistory
        open={openmedHis}
        onClose={() => setopenmedHis(false)}
        id={selectedPatient ? selectedPatient.id: ''}
       // onSubmit={getCCCData}
     />


  <SpecialPrecautionDialog
  open={precautionDialogOpen}
  onClose={() => setPrecautionDialogOpen(false)}
  patient={selectedPatient}
/>


<ChronicMedicationDialog
  open={chronicDialogOpen}
  onClose={() => setChronicDialogOpen(false)}
  meds={chronicMeds}

/>


{/* ── Stock Warning Dialog ── */}
<Dialog
  open={stockWarningDialog}
  onClose={() => !notifyingPharmacy && setStockWarningDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ p: 0 }}>
    <Box sx={{
      px: 3, py: 2,
      background: 'linear-gradient(135deg, #da231d 0%, #da231d 100%)',
      color: 'white',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    }}>
      <Typography variant="h6" fontWeight={700}>⚠️ Insufficient Stock</Typography>
      <IconButton
        onClick={() => setStockWarningDialog(false)}
        disabled={notifyingPharmacy}
        sx={{ color: 'white' }}
      >
        <Close />
      </IconButton>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ pt: 3 }}>
    {stockWarningInfo && (
      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          There is not enough stock in the dispensary for:
        </Typography>

        <Paper sx={{ p: 2, mb: 2, bgcolor: '#fff3e0', border: '1px solid #ff9800', borderRadius: 2 }}>
          <Typography fontWeight={700} fontSize="1rem" color="warning.dark">
            {stockWarningInfo.drugName}
          </Typography>
          <Box sx={{ mt: 1, display: 'flex', gap: 3 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">Requested</Typography>
              <Typography fontWeight={700} color="primary">{stockWarningInfo.requestedQty}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Available</Typography>
              <Typography fontWeight={700} color="success.main">{stockWarningInfo.availableStock}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Shortfall</Typography>
              <Typography fontWeight={700} color="error">
                {stockWarningInfo.requestedQty - stockWarningInfo.availableStock}
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Typography variant="body2" color="text.secondary">
          You can notify the pharmacy to restock, or Cancel request.
        </Typography>
      </Box>
    )}
  </DialogContent>

<DialogActions sx={{ p: 2, gap: 1, flexWrap: 'wrap' }}>
  <Button
    variant="contained"
    color="warning"
    disabled={notifyingPharmacy}
    onClick={() => handleNotifyPharmacy(true)}
    sx={{ fontWeight: 600, flex: 1 }}
  >
    {notifyingPharmacy
      ? <CircularProgress size={20} />
      : '📢 Notify Pharmacy & Submit'}
  </Button>
  <Button
    variant="outlined"
    color="error"
    disabled={notifyingPharmacy}
    onClick={() => setStockWarningDialog(false)}
    sx={{ fontWeight: 600, flex: 1 }}
  >
    Cancel
  </Button>
</DialogActions>
</Dialog>

        </>
        )}
</Container>
</Box>
  );
};

export default OutPatient;


